// src/modules/productCatalog.js
// Auto-generated from CSV — 1612 products across 12 manufacturers
// DO NOT EDIT MANUALLY — regenerate from source CSV

export const MANUFACTURERS = 
[
  {
    "id": "chemori",
    "name": "Chemori",
    "logoKey": "chemori",
    "products": [
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CHEMORI FK5112",
        "description": "FACTORY FILLED FK-5-1-12 CLEAN AGENT (PER LB)",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70020-E-SS",
        "description": "20 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70035-E-SS",
        "description": "35 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70070-E-SS",
        "description": "70 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70100-F-SS",
        "description": "100 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70150-E-SS",
        "description": "150 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70250-E-SS",
        "description": "250 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70375-E-SS",
        "description": "375 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70560-E-SS",
        "description": "560 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70650-F",
        "description": "650 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70800-F",
        "description": "800 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 71000-F",
        "description": "1000 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 71200-E",
        "description": "1200 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70020-E-SS-MF",
        "description": "20 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70035-E-SS-MF",
        "description": "35 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70070-E-SS-MF",
        "description": "70 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70100-F-SS-MF",
        "description": "100 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70150-E-SS-MF",
        "description": "150 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70250-E-SS-MF",
        "description": "250 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70375-E-SS-MF",
        "description": "375 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70560-E-SS-MF",
        "description": "560 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70650-F-MF",
        "description": "650 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70800-F-MF",
        "description": "800 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 71000-F-MF",
        "description": "1000 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 71200-E-MF",
        "description": "1200 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70020-E-SS-GLD",
        "description": "20 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70035-E-SS-GLD",
        "description": "35 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70070-E-SS-GLD",
        "description": "70 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70100-F-SS-GLD",
        "description": "100 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70150-E-SS-GLD",
        "description": "150 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70250-E-SS-GLD",
        "description": "250 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70375-E-SS-GLD",
        "description": "375 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70560-E-SS-GLD",
        "description": "560 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70650-F-GLD",
        "description": "650 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 70800-F-GLD",
        "description": "800 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 71000-F-GLD",
        "description": "1000 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 71200-E-GLD",
        "description": "1200 LB STAINLESS STEEL CYCLINDER ASSEMBLY W/ SS VALVE - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 50139",
        "description": "20/35/70 LBS CYLINDER STRAP - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60780",
        "description": "100/150 LBS CYLINDER STRAP - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60760",
        "description": "250 LBS CYLINDER STRAP - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60760",
        "description": "375 LBS CYLINDER STRAP - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60770",
        "description": "560/650 LBS CYLINDER STRAP - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60790",
        "description": "800/1,000/1,200 LBS CYLINDER STRAP - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60792",
        "description": "800/1,000/1,200 LBS CYLINDER FLOOR STRAP - RED",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 50139-MF",
        "description": "20/35/70 LBS CYLINDER STRAP - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60780-MF",
        "description": "100/150 LBS CYLINDER STRAP - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60760-MF",
        "description": "250 LBS CYLINDER STRAP - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60760-MF",
        "description": "375 LBS CYLINDER STRAP - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60770-MF",
        "description": "560/650 LBS CYLINDER STRAP - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60790-MF",
        "description": "800/1,000/1,200 LBS CYLINDER STRAP - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60792-MF",
        "description": "800/1,000/1,200 LBS CYLINDER FLOOR STRAP - MIRROR FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 50139-GLD",
        "description": "20/35/70 LBS CYLINDER STRAP - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60780-GLD",
        "description": "100/150 LBS CYLINDER STRAP - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60760-GLD",
        "description": "250 LBS CYLINDER STRAP - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60760-GLD",
        "description": "375 LBS CYLINDER STRAP - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60770-GLD",
        "description": "560/650 LBS CYLINDER STRAP - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60790-GLD",
        "description": "800/1,000/1,200 LBS CYLINDER STRAP - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60792-GLD",
        "description": "800/1,000/1,200 LBS CYLINDER FLOOR STRAP - GOLD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 51120250",
        "description": "FK -5-1-12 CLEAN AGENT DRUM - 551 LB",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 51120500-FULL",
        "description": "FK -5-1-12 CLEAN AGENT STAINLESS STEEL DRUM - FULL (1,102LB)",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 50026-A",
        "description": "LATCHING SOLENOID WITH SUPERVISION",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 61033-2",
        "description": "LATCHING SOLENOID ELECTRIC SOLENOID",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 61041",
        "description": "PISTON ACTUATOR SLAVE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 50025-2",
        "description": "ELECTRIC SOLENOID 11 WATTS 24 VDC",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 50025-6",
        "description": "ELECTRIC SOLENOID 15 WATTS 24 VDC",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CA61034",
        "description": "ELECTRIC SOLENOID LOCAL MANUAL CONTROL",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 50138-9",
        "description": "PRESSURE SUPERVISORY SWITCH (N/C) 500PSI & GUARD",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 50138-1M2316L",
        "description": "SS PRESSURE SUPERVISORY SWITCH (N/C) 500PSI (M10 THREAD)",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 50339",
        "description": "DISCHARGE PRESSURE SUPERVISORY SWITCH SPDT",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 80704-2-0.XXXX",
        "description": "1/2 in. 180° SIDEWALL NOZZLE - STAINLESS STEEL",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 80704-3-0.XXXX",
        "description": "1/2 in. 360° CENTRAL NOZZLE - STAINLESS STEEL",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 80705-2-0.XXXX",
        "description": "3/4 in. 180° SIDEWALL NOZZLE - STAINLESS STEEL",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 80705-3-0.XXXX",
        "description": "3/4 in. 360° CENTRAL NOZZLE - STAINLESS STEEL",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 80706-2-0.XXXX",
        "description": "1 in. 180° SIDEWALL NOZZLE - STAINLESS STEEL",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 80706-3-0.XXXX",
        "description": "1 in. 360° CENTRAL NOZZLE - STAINLESS STEEL",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 80707-2-0.XXXX",
        "description": "1 - 1/4 in. 180° SIDEWALL NOZZLE - STAINLESS STEEL",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 80707-3-0.XXXX",
        "description": "1 - 1/4 in. 360° CENTRAL NOZZLE - STAINLESS STEEL",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 80708-2-0.XXXX",
        "description": "1 - 1/2 in. 180° SIDEWALL NOZZLE - STAINLESS STEEL",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 80708-3-0.XXXX",
        "description": "1 - 1/2 in. 360° CENTRAL NOZZLE - STAINLESS STEEL",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 80709-2-0.XXXX",
        "description": "2 in. 180° SIDEWALL NOZZLE - STAINLESS STEEL",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 80709-3-0.XXXX",
        "description": "2 in. 360° CENTRAL NOZZLE - STAINLESS STEEL",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60255",
        "description": "1 in. NPT FLEXIBLE CYLINDER HOSE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60256",
        "description": "1 - 1/2 in. NPT FLEXIBLE CYLINDER HOSE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60257",
        "description": "2 - 1/2 in. NPT FLEXIBLE CYLINDER HOSE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 91230-C",
        "description": "3 in. NPT SS BRAID FLEXIBLE CYLINDER HOSE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 91230",
        "description": "4 in. NPT SS BRAID FLEXIBLE CYLINDER HOSE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60020",
        "description": "LIQUID LEVEL INDICATOR 150 / 250 LB. CYLINDER",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60020-1",
        "description": "LIQUID LEVEL INDICATOR 375 / 560 LB. CYLINDER",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60020-5",
        "description": "LIQUID LEVEL INDICATOR 650 LB. CYLINDER",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60020-4",
        "description": "LIQUID LEVEL INDICATOR 800 LB. CYLINDER",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60020-3",
        "description": "LIQUID LEVEL INDICATOR 1,000 LB. CYLINDER",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60020-2",
        "description": "LIQUID LEVEL INDICATOR 1,200 LB. CYLINDER",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 50192-2",
        "description": "1/4 in. x 36 in. METAL FLEXIBLE HOSE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 50192-3",
        "description": "1/4 in. x 12 in. METAL FLEXIBLE HOSE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 50192-1",
        "description": "1/4 in. x 24 in. METAL FLEXIBLE HOSE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60261",
        "description": "1 in. CHECK VALVE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60262",
        "description": "1 - 1/2 in. CHECK VALVE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60263",
        "description": "2 - 1/2 in. CHECK VALVE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 91231-3",
        "description": "3 in. CHECK VALVE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 91231-2",
        "description": "4 in. CHECK VALVE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 603297-P",
        "description": "1 in. SELECTOR VALVE W/ PNEUMATIC ACTUATOR (THREADED) & LIMIT SWITCH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 603299-P",
        "description": "1 - 1/2 in. SELECTOR VALVE W/ PNEUMATIC ACTUATOR (THREADED) & LIMIT SWITCH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 603300-P",
        "description": "2 in. SELECTOR VALVE W/ PNEUMATIC ACTUATOR (THREADED) & LIMIT SWITCH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 603301-P",
        "description": "2 - 1/2 in. SELECTOR VALVE W/ PNEUMATIC ACTUATOR (THREADED) & LIMIT SWITCH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 603302-P",
        "description": "3 in. SELECTOR VALVE W/ PNEUMATIC ACTUATOR (THREADED) & LIMIT SWITCH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 603303-P",
        "description": "4 in. SELECTOR VALVE W/ PNEUMATIC ACTUATOR (THREADED) & LIMIT SWITCH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 603304-P",
        "description": "6 in. SELECTOR VALVE W/ PNEUMATIC ACTUATOR (THREADED) & LIMIT SWITCH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 5000-3",
        "description": "VALVE SERVICE KIT 1 in. SS VALVE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 5000",
        "description": "VALVE SERVICE KIT 1 - 1/2 in. SS VALVE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 5000-1",
        "description": "VALVE SERVICE KIT 2 - 1/2 in. SS VALVE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 5000-13",
        "description": "VALVE SERVICE KIT 3 in. SS VALVE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 5000-12",
        "description": "VALVE SERVICE KIT4 in. SS VALVE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 7181013",
        "description": "KRCP3 RELEASING FIRE CONTROL PANEL",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 61051-MP",
        "description": "DUAL ACTION MANUAL PULL STATION, KEY RESET, LIFT & PULL TYPE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 88105",
        "description": "ABORT SWITCH W/ BACK BOX",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 88205",
        "description": "RELEASING CIRCUIT DISABLE SWITCH, 24 VDC W/ BACK BOX",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60911",
        "description": "MAIN RESERVE SWITCH W/ BACK BOX",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60046",
        "description": "PHOTO-ELECTRIC SMOKE DETECTOR SERIES 65A W/ BASE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60047",
        "description": "THERMAL DETECTOR SERIES 65A W/ BASE",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR B6-24",
        "description": "6\" BELL, 24 VDC W/ BACKBOX",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 1750110",
        "description": "8\" BELL, 24 VDC RED FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 1750090",
        "description": "10\" BELL, 25 VDC RED FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 44211",
        "description": "HORN/STRONE, 24VDC, WALL MOUNT RED, 75 CANDELA, WEATHER PROOF",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 44202",
        "description": "SELECT A-HORN, 12/24VDC, RED FINISH",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 88114",
        "description": "EVACUATE STROBE LIGHT BOX",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 88115",
        "description": "GAS DISCHARGE STROBE LIGHT BOX",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60230",
        "description": "CAUTION LABEL - FK5112 - WHEN ALARM SOUNDS...",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60231",
        "description": "CAUTION LABEL - FK5112 - DO NOT ENTER",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "CR 60235",
        "description": "CAUTION - ROOM PROTECTED BY FK5112",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "LA-7001",
        "description": "PRE-ENGINEERED MARKETING KIT - TEMPLATE 1",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "LA-7002",
        "description": "DAR/SAR MARKETING KIT - TEMPLATE 2",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "LA-7003",
        "description": "CROSS SECTION MARKETING KIT - TEMPLATE 3",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "LA-7004",
        "description": "STAINLESS STEEL ACCESSORIES MARKETING KIT - TEMPLATE 4",
        "incoterms": "Singapore"
      },
      {
        "category": "TOTAL FLOODING",
        "partNumber": "LA-7005",
        "description": "STAINLESS STEEL CHECK VALVE MARKETING KIT - TEMPLATE 5",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR K3D-SF",
        "description": "DAR 3LB CYLINDER FK5112  W/ PRESSURE GAUGE, SS BRACKET - STANDARD FILL",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR K6D-SF",
        "description": "DAR 6LB CYLINDER FK5112 W/ PRESSURE GAUGE, SS BRACKET - STANDARD FILL",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR K12D-SF",
        "description": "DAR 12LB CYLINDER FK5112  W/ PRESSURE GAUGE, SS BRACKET - STANDARD FILL",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR K18D-SF",
        "description": "DAR 18LB CYLINDER FK5112  W/ PRESSURE GAUGE, SS BRACKET - STANDARD FILL",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR K3S-SF",
        "description": "SAR 3LB CYLINDER FK5112  W/ PRESSURE GAUGE, SS BRACKET - STANDARD FILL",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR K6S-SF",
        "description": "SAR 6LB CYLINDER FK5112 W/ PRESSURE GAUGE, SS BRACKET - STANDARD FILL",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR K12S-SF",
        "description": "SAR 12LB CYLINDER FK5112  W/ PRESSURE GAUGE, SS BRACKET - STANDARD FILL",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR K18S-SF",
        "description": "SAR 18LB CYLINDER FK5112  W/ PRESSURE GAUGE, SS BRACKET - STANDARD FILL",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR K3-PE-SF",
        "description": "PRE-ENG 3LB CYLINDER FK5112  W/ PRESSURE GAUGE, SS BRACKET - STANDARD FILL",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR K6-PE-SF",
        "description": "PRE-ENG 6LB CYLINDER FK5112 W/ PRESSURE GAUGE, SS BRACKET - STANDARD FILL",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR K12-PE-SF",
        "description": "PRE-ENG 12LB CYLINDER FK5112  W/ PRESSURE GAUGE, SS BRACKET - STANDARD FILL",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR K18-PE-SF",
        "description": "PRE-ENG 18LB CYLINDER FK5112  W/ PRESSURE GAUGE, SS BRACKET - STANDARD FILL",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 60010",
        "description": "ELECTRIC MICRO SOLENOID 11 WATTS 24 VDC W/O SUPERVISION",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 27-15-18-DC-3",
        "description": "PRESSURE GAUGE 195PSI M10-1",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 99001",
        "description": "DIRECT MANUAL RELEASE ASSEMBLY W/ PRESSURE GAUGE",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 62033",
        "description": "WALL MOUNT RELEASE ASSEMBLY C/W PRESSURE GAUGE",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 99025",
        "description": "END-OF-LINE ADAPTER W/ SCHRADER VALVE, NUTS & SLIP LOCK ADAPTER",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 60032-A",
        "description": "1/8\" BSPP WITH SLIP LOCK ADAPTER (6MM)",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 60035-A",
        "description": "6MM SLIP LOCK JOINT",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 60033-A",
        "description": "ELBOW: 1/8\" BSPP X SLIP LOCK",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 60036-A",
        "description": "ELBOW:  SLIP LOCK ELBOW",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 60034-A",
        "description": "TEE JOINT: 1/8\" BSPP X SLIP LOCKS",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 60037-A",
        "description": "TEE JOINT: SLIP LOCK (ALL ENDS)",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 99011-R6-ROLL",
        "description": "FIRE DETECTION TUBBING RED 100C (ID:4MM, OD:6MM) - [100M ROLL]",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 99011-B6-ROLL",
        "description": "FIRE DETECTION TUBBING RED 125C (ID:4MM, OD:6MM) - [100M ROLL]",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 99020",
        "description": "DETECTION TUBBING GUARD W CONNECTOR - [1.2 METER]",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 99071",
        "description": "TUBBING CUTTER TOOL",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 89801",
        "description": "PUSH BUTTON WITH LIGHT",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 60016",
        "description": "MINI STROBE HORN",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 80704-3",
        "description": "1/2\" 360 CLEAN AGENT NOZZLE - STAINLESS STEEL",
        "incoterms": "Singapore"
      },
      {
        "category": "MICRO SUPPRESSION",
        "partNumber": "CR 99078",
        "description": "TYPE C CLEAN AGENT CONE NOZZLE - STAINLESS STEEL",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CHEMORI-ECO7",
        "description": "25 KILOGRAMS ECO7 CONCENTRATE CONTAINER LIQUID AGENT",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CHEMORI-ECO7-1",
        "description": "200 KILOGRAMS ECO7 CONCENTRATE CONTAINER LIQUID AGENT",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 991003-S",
        "description": "SAR 3LB CYLINDER ECO7  W/ PRESSURE GAUGE, SS BRACKET",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 991006-S",
        "description": "SAR 6LB CYLINDER ECO7  W/ PRESSURE GAUGE, SS BRACKET",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 991012-S",
        "description": "SAR 12LB CYLINDER ECO7  W/ PRESSURE GAUGE, SS BRACKET",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 991018-S",
        "description": "SAR 18LB CYLINDER ECO7  W/ PRESSURE GAUGE, SS BRACKET",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 991035-S",
        "description": "SAR 35LB CYLINDER ECO7  W/ PRESSURE GAUGE, SS BRACKET",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 991070-S",
        "description": "SAR 70LB CYLINDER ECO7  W/ PRESSURE GAUGE, SS BRACKET",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 991100-S",
        "description": "SAR 100LB CYLINDER ECO7  W/ PRESSURE GAUGE, SS BRACKET",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 991035-F",
        "description": "PRE-ENG 35LB CYLINDER ECO7  W/ PRESSURE GAUGE, SS BRACKET",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 991070-F",
        "description": "PRE-ENG 70LB CYLINDER ECO7  W/ PRESSURE GAUGE, SS BRACKET",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 991100-F",
        "description": "PRE-ENG 100LB CYLINDER ECO7  W/ PRESSURE GAUGE, SS BRACKET",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 27-15-18-A",
        "description": "PRESSURE GAUGE 240PSI M10-1",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 50138-3",
        "description": "PRESSURE SUPERVISORY SWITCH (N/C) 135PSI",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 99730",
        "description": "ECO7 1/2\" NOZZLE 30 DEG ANGLE SPRAY",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 990001-XV",
        "description": "WIDE MIST ECO7 NOZZLE 1/8\" NPT",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 990002-IP",
        "description": "DIRECTIONAL MIST NOZZLE 1/4\" NPT",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 60010",
        "description": "ELECTRIC MICRO SOLENOID 11 WATTS 24 VDC W/O SUPERVISION",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 99001",
        "description": "DIRECT MANUAL RELEASE ASSEMBLY W/ PRESSURE GAUGE",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 62033",
        "description": "WALL MOUNT RELEASE ASSEMBLY C/W PRESSURE GAUGE",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 99025",
        "description": "END-OF-LINE ADAPTER W/ SCHRADER VALVE, NUTS & SLIP LOCK ADAPTER",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 60032-A",
        "description": "1/8\" BSPP WITH SLIP LOCK ADAPTER (6MM)",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 60035-A",
        "description": "6MM SLIP LOCK JOINT",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 60033-A",
        "description": "ELBOW: 1/8\" BSPP X SLIP LOCK",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 60036-A",
        "description": "ELBOW:  SLIP LOCK ELBOW",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 60034-A",
        "description": "TEE JOINT: 1/8\" BSPP X SLIP LOCKS",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 60037-A",
        "description": "TEE JOINT: SLIP LOCK (ALL ENDS)",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 99011-R6-ROLL",
        "description": "FIRE DETECTION TUBBING RED 100C (ID:4MM, OD:6MM) - [100M ROLL]",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 99011-B6-ROLL",
        "description": "FIRE DETECTION TUBBING RED 125C (ID:4MM, OD:6MM) - [100M ROLL]",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 99020",
        "description": "DETECTION TUBBING GUARD W CONNECTOR - [1.2 METER]",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 99071",
        "description": "TUBBING CUTTER TOOL",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 89801",
        "description": "PUSH BUTTON WITH LIGHT",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 60016",
        "description": "MINI STROBE HORN",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 7181013",
        "description": "KRCP3 RELEASING FIRE CONTROL PANEL",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 60143",
        "description": "STAINLESS STEEL FIXED TEMPERATURE DETECTOR (PRE-SET 232° C)",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 61051-MP",
        "description": "DUAL ACTION MANUAL PULL STATION, KEY RESET, LIFT & PULL TYPE",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 50078",
        "description": "GAS SHUT-OFF 1/2 IN. NPT VALVE, DC24V",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 50079",
        "description": "GAS SHUT-OFF 3/4 IN. NPT VALVE, DC24V",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 50080",
        "description": "GAS SHUT-OFF 1 IN. NPT VALVE, DC24V",
        "incoterms": "Singapore"
      },
      {
        "category": "ECO7",
        "partNumber": "CR 40235",
        "description": "WALL SIGN - AREA PROTECTED SIGNAGE FOR ECO7",
        "incoterms": "Singapore"
      }
    ]
  },
  {
    "id": "ava",
    "name": "AVA",
    "logoKey": "ava",
    "products": [
      {
        "category": "ASD",
        "partNumber": "CSD-H10",
        "description": "Small spaces ASD, Smoke, Temp & humidity sensors",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD",
        "partNumber": "CSD-H10P",
        "description": "Small spaces ASD, Smoke, Temp & humidity sensors w/o Aspirator",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD",
        "partNumber": "CSD-H11",
        "description": "Small spaces ASD, Smoke, Temp, humidity & CO sensors",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD",
        "partNumber": "HM1",
        "description": "Cupid ASD, 1 Pipe, 1 Zone - Temp & humidity sensors",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD",
        "partNumber": "HM1D",
        "description": "Cupid ASD, 1 Pipe, 1 Zone - Temp, humidity, CO sensors",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD",
        "partNumber": "HM2",
        "description": "Cupid ASD, 2 Zone, Double Sensor, Release Control - Temp & humidity sensors",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD",
        "partNumber": "HM2D",
        "description": "Cupid ASD, 2 Zone, Double Sensor, Release Control - Temp, humidity & CO sensors",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD",
        "partNumber": "Quartas-200r",
        "description": "Quartas ASD, Single Pipe, Relay",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD",
        "partNumber": "Quartas-200s",
        "description": "Quartas ASD, Single Pipe, Network",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD",
        "partNumber": "Quartas-300r",
        "description": "Quartas ASD, Single Pipe, Relay",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD",
        "partNumber": "Quartas-300s",
        "description": "Quartas ASD, Single Pipe, Network",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD",
        "partNumber": "Quartas-500r",
        "description": "Quartas ASD, Single Pipe, Relay",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD",
        "partNumber": "Quartas-500s",
        "description": "Quartas ASD, Single Pipe, Network",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD",
        "partNumber": "Quartas-2000s-1A",
        "description": "Quartas ASD, 4 Pipes, 1 Zone, Network Connection",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD",
        "partNumber": "Quartas-2000s-4A",
        "description": "Quartas ASD, 4 Pipes Addressable (Scan), Network",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD",
        "partNumber": "Quartas-2000s-4A-16",
        "description": "Quartas ASD, 4 Pipes Addressable (Scan), Network, 4 zones relay board (16 relays)",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD",
        "partNumber": "CSD-H10-MIA",
        "description": "Small spaces ASD, Smoke, Temp & humidity sensors",
        "incoterms": "Miami"
      },
      {
        "category": "ASD",
        "partNumber": "HM1-MIA",
        "description": "Cupid ASD, 1 Pipe, 1 Zone - Temp & humidity sensors",
        "incoterms": "Miami"
      },
      {
        "category": "ASD",
        "partNumber": "HM2-MIA",
        "description": "Cupid ASD, 2 Zone, Double Sensor, Release Control - Temp & humidity sensors",
        "incoterms": "Miami"
      },
      {
        "category": "ASD",
        "partNumber": "Quartas-300r-MIA",
        "description": "Quartas ASD, Single Pipe, Relay",
        "incoterms": "Miami"
      },
      {
        "category": "ASD",
        "partNumber": "Quartas-500r-MIA",
        "description": "Quartas ASD, Single Pipe, Relay",
        "incoterms": "Miami"
      },
      {
        "category": "ASD",
        "partNumber": "Quartas-2000s-4A-MIA",
        "description": "Quartas ASD, 4 Pipes Addressable, Network Connection",
        "incoterms": "Miami"
      },
      {
        "category": "ASD Accessories",
        "partNumber": "RDU-PMC",
        "description": "Panel Mount Remote Display Unit",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD Accessories",
        "partNumber": "ASP-0102-08",
        "description": "External Filter for connection with 8mm OD tube",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD Accessories",
        "partNumber": "ASP-0102-25",
        "description": "External Filter for connection with 25mm OD tube",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD Accessories",
        "partNumber": "NIM-1200-96",
        "description": "Network Interface Module with HDMI",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD Accessories",
        "partNumber": "NCP-1215-96",
        "description": "Network Control Panel with integrated 15\" touch screen display",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD Accessories",
        "partNumber": "ASP-0021",
        "description": "Pipe adaptor 25mm to 3/4\"",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD Accessories",
        "partNumber": "ASP-0001",
        "description": "Standard Sampling Point Label per 6",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD Accessories",
        "partNumber": "ASP-0002",
        "description": "Sampling Hole Label per 10",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD Accessories",
        "partNumber": "ASP-0003",
        "description": "Brass Sampling Point (hole size: 2mm)",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD Accessories",
        "partNumber": "ASP-0005",
        "description": "Standard Sampling Point Assembly (Bead Sampling Point – Washer - Nut)",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD Accessories",
        "partNumber": "ASP-0012",
        "description": "PU Tube 5×8mm (100m/Roll)",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD Accessories",
        "partNumber": "ASP-0100",
        "description": "Dual Stage Filter (Built-in)",
        "incoterms": "Taiwan"
      },
      {
        "category": "ASD Accessories",
        "partNumber": "PASD-100",
        "description": "Portable Aspirating Smoke testing unit",
        "incoterms": "Taiwan"
      }
    ]
  },
  {
    "id": "boal",
    "name": "Boal Systems",
    "logoKey": "boal",
    "products": [
      {
        "category": "AVA e-Learning",
        "partNumber": "AVA-TRAIN1",
        "description": "Training Kit (eLearning, AVA Tool Softwr, AVA Flow Softwr, Quartas-300r, USB/RS485 Conctr, 24VDC Power Supply)",
        "incoterms": "Miami"
      },
      {
        "category": "AVA e-Learning",
        "partNumber": "AVA-TRAIN2",
        "description": "Training Kit (eLearning, AVA Tool Softwr, AVA Flow Softwr, Quartas-500r, USB/RS485 Conctr, 24VDC Power Supply)",
        "incoterms": "Miami"
      },
      {
        "category": "AVA e-Learning",
        "partNumber": "AVA-TRAIN3",
        "description": "Training Kit (eLearning, AVA Tool Softwr, AVA Flow Softwr, CSD-H10, USB/RS485 Conctr, 24VDC Power Supply)",
        "incoterms": "Miami"
      },
      {
        "category": "AVA e-Learning",
        "partNumber": "AVA-TRAING-KIT",
        "description": "Training Kit (eLearning Course, AVA Tool Software, AVA Flow Software, Quartas 300r, CUPID HM2, USB/RS485 Conector Qty. 2 , 24VDC Power Supply Qty. 2)",
        "incoterms": "Miami"
      },
      {
        "category": "Chemori e-Learning",
        "partNumber": "E-LEARN-SUPR",
        "description": "CLEAN AGENT SUPPRESSION E-LEARNING (INCLUDES: CHEMORI TRAINING MODULES, BOM GENERATOR & PRE-CALCULATION SOFTWARE, TECHNICAL MANUALS AND DOCUMENTATION)",
        "incoterms": "Digital"
      }
    ]
  },
  {
    "id": "potter",
    "name": "Potter",
    "logoKey": "potter",
    "products": [
      {
        "category": "Addressable Releasing Panels",
        "partNumber": "3992714",
        "description": "IPA-60: 60 Point Addressable Fire, Releasing Panel",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panels",
        "partNumber": "3992715",
        "description": "IPA-100: 127 Point Addressable Fire, Releasing Panel",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panels",
        "partNumber": "3992717",
        "description": "IPA-4000: 127-4064 Point Addressable Fire, Releasing Panel",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panels",
        "partNumber": "3992738",
        "description": "IPA-60 RB: Replacement Board for IPA-60",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panels",
        "partNumber": "3992739",
        "description": "IPA-100 RB: Replacement Board for IPA-100",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panels",
        "partNumber": "3992740",
        "description": "IPA-4000 RB: Replacement Board for IPA-4000",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panels",
        "partNumber": "3993101",
        "description": "IPA-4000-PT: 4064 POINT ADDRESSABLE FIRE PANEL PORTUGUESE",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panels",
        "partNumber": "3993103",
        "description": "IPA-100-PT: 127 POINT ADDRESSABLE FIRE PANEL PORTUGUESE",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panels",
        "partNumber": "3993105",
        "description": "IPA-60-PT: 60 POINT ADDRESSABLE FIRE PANEL PORTUGUESE",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panels",
        "partNumber": "3993119",
        "description": "REPLACEMENT BOARD IPA-4000-PT",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panels",
        "partNumber": "3993121",
        "description": "REPLACEMENT BOARD IPA-100-PT",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panels",
        "partNumber": "3993123",
        "description": "REPLACEMENT BOARD IPA-60-PT",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panels",
        "partNumber": "3993104",
        "description": "IPA-60-SP: 60 POINT ADDRESSABLE FIRE PANEL SPANISH",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panels",
        "partNumber": "3993102",
        "description": "IPA-100-SP: 127 POINT ADDRESSABLE FIRE PANEL SPANISH",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panels",
        "partNumber": "3993100",
        "description": "IPA-4000-SP: 4064 POINT ADDRESSABLE FIRE PANEL SPANISH",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panels",
        "partNumber": "3993122",
        "description": "REPLACEMENT BOARD IPA-60-SP",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panels",
        "partNumber": "3993120",
        "description": "REPLACEMENT BOARD IPA-100-SP",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panels",
        "partNumber": "3993118",
        "description": "REPLACEMENT BOARD IPA-4000-SP",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992788",
        "description": "NCE-1000: NCE-1000 NETWORK CARD-CAT5",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992789",
        "description": "NCF-1000: NCF-1000 NETWORK CARD-FIBER",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992790",
        "description": "SFP-MM: MULTI-MODE FIBER",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992791",
        "description": "SFP-SM: SINGLE-MODE FIBER",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3993140",
        "description": "PSK-1000B: PROGRAMMABLE SOFT KEYS BOARD ONLY",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3993141",
        "description": "SCUI-1000B: SMOKE CONTROL USER INTERFACE BOARD ONLY",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3993142",
        "description": "PSK-1000: PROGRAMMABLE SOFT KEYS PANEL",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3993143",
        "description": "SCUI-1000: SMOKE CONTROL USER INTERFACE PANEL",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3006459",
        "description": "CA-6075: Class A Expander",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992662",
        "description": "PSN-1000: Intelligent Power Expander",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992663",
        "description": "CA-6500: Class A Expander",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992664",
        "description": "SLCE-127: SLC Expander Compatible with Nohmi protocol devices",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992665",
        "description": "PSN-1000E: Intelligent Power Expander Large Cabinet",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992667",
        "description": "RLY-5: Relay Module",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992668",
        "description": "DRV-50: LED Driver Module",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992669",
        "description": "FCB-1000: Fire Communication Bridge",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992670",
        "description": "SPG-1000: Serial Parallel Gateway/Printer Interface",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992671",
        "description": "FIB-1000: Fiber Interface Bridge",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992672",
        "description": "FCBRM-1000: Rack Mount Fire Communication Bridge",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992673",
        "description": "SPG-1000RM: Serial Parallel Gateway/Printer Interface (Rack)",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992674",
        "description": "FIB-1000RM: Rack Mount Fiber Interface Bridge",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992675",
        "description": "AE-8: 8 Card Accessory Enclosure",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992676",
        "description": "AE-14: 14 Card Accessory Enclosure",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992722",
        "description": "PAD100-SLCE: PAD 100 127 Point SLC Expander Compatible with PAD protocol devices",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992723",
        "description": "MC-1000: MC-1000 Multi Connect",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992726",
        "description": "AE-2: TWO CARD ACCESSORY ENCLOSURE",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992362",
        "description": "IDC-6: Initiating Device Circuit Expander",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992775",
        "description": "PAD300-PD: PAD300 PHOTO DETECTOR",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992776",
        "description": "PAD300-HD: PAD300 HEAT DETECTOR",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992777",
        "description": "PAD300-PHD: PAD300 PHOTO/HEAT DETECTOR",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992778",
        "description": "PAD300-CD: PAD300 CO DETECTOR",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992779",
        "description": "PAD300-PCD: PAD300 PHOTO/CO DETECTOR",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992781",
        "description": "PAD300-4DB: 4\" DETECTOR BASE",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992782",
        "description": "PAD300-6DB: 6\" DETECTOR BASE",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992783",
        "description": "PAD300-IB: ISOLATOR BASE",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992784",
        "description": "PAD300-RB: RELAY BASE",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992785",
        "description": "PAD300-SB: SOUNDER BASE",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992786",
        "description": "PAD300-LFSB: LOW FREQUENCY SOUNDER BASE",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992795",
        "description": "PAD300-DUCT: PAD300 DUCT DETECTOR",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992796",
        "description": "PAD300-DUCTR: PAD300 DUCT DETECTOR W/RELAY",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992797",
        "description": "PAD300-DD: PAD300 DUCT PHOTO DETECTOR",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3993783",
        "description": "PAD300 Magnet:",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992711",
        "description": "PAD100-DRTS: PAD 100 Duct Remote Test  (PAD100 - Ductr Only)",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992700",
        "description": "PAD100-MIM: PAD 100 Micro Input Module",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992701",
        "description": "PAD100-TRTI: PAD 100 Two Relay /Two Input",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992702",
        "description": "PAD100-OROI: PAD 100 One Relay /One Input",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992703",
        "description": "PAD100-DIM: PAD 100 Dual Input Module",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992704",
        "description": "PAD100-SIM: PAD 100 Single Input Module",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992705",
        "description": "PAD100-RM: PAD 100 Relay Module",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992706",
        "description": "PAD100-ZM: PAD 100 Zone Module",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992707",
        "description": "PAD100-NAC: PAD 100 Notification Appliance Circuit",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992708",
        "description": "PAD100-IM: PAD 100 Isolator Module",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992709",
        "description": "PAD100-LEDK: PAD 100 LED With Keyswitch",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992710",
        "description": "PAD100-LED: PAD 100 Addressable LED Module",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992720",
        "description": "PAD100-PSDA: PAD 100 Addressable Pull Station Dual Action",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992721",
        "description": "PAD100-PSSA: PAD 100 Addressable Pull Station Single Action",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992724",
        "description": "PAD100-SM: PAD 100 Speaker/Audio Module",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992727",
        "description": "LED-16F: LED ANNUNCIATOR 16 ZONES FLUSH MOUNT",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3006458",
        "description": "RA-6075: 32 Character LCD Remote Annuncator",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3006462",
        "description": "RA-6075R: 32 Character LCD Remote Annuncator, Releasing",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992660",
        "description": "RA-6500: 160 Char LCD Remote Anctr  Red Enclosure",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992661",
        "description": "RA-6500R: 160 Char LCD Remote Anctr  Red Enclosure, Releasing",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992666",
        "description": "LED-16: LED Annunciator",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992725",
        "description": "RA-6500FR: 160 Char LCD Remote Anctr, Flush Mt, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992741",
        "description": "RA-6500FB: 160 Char LCD Remote Anctr, Flush Mt,  Black",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992742",
        "description": "RA-6500FDG: 160 Char LCD Remote Anctr, Flush Mt, Dark Gray",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992743",
        "description": "RA-6500FLG: 160 Char LCD Remote Anctr, Flush Mt, Light Gray",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992747",
        "description": "RA-6500R: 160 Char LCD Remote Anctr,  Black",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992748",
        "description": "RA-6500DG: 160 Char LCD Remote Anctr, Dark Gray",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "3992749",
        "description": "RA-6500LG: 160 Char LCD Remote Anctr, Light Gray",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "1000274",
        "description": "STN-2.5: 2.5' Sampling Tube For  Addressable Duct Detector",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "1000275",
        "description": "STN-5: 5' Sampling Tube For Addressable and Nohmi Duct Detector",
        "incoterms": "Miami"
      },
      {
        "category": "Addressable Releasing Panel Peripherals",
        "partNumber": "1000276",
        "description": "STN-10: 10' Sampling Tube For Addressable Duct Detector",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panels",
        "partNumber": "3006735",
        "description": "PFC-4410G3: CONVENTIONAL PANEL, RED CABINET",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "1000484",
        "description": "DGB-R: Abort Switch Red Back Box",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "3001000",
        "description": "ABORT-R: Abort Switch Red Button",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "3001002",
        "description": "RCDS-1: Release Ckt Disable Switch",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "3001003",
        "description": "MRS: Main/Reserve Switch For Agent Release",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "3001004",
        "description": "ABORT-B: Abort Switch Blue Button",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "3001010",
        "description": "MAS-R: Manual Release/Abort Station Red Pull",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "3001011",
        "description": "MAS-Y: Manual Release/Abort Station Yellow Pull",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "3001012",
        "description": "MAS-MP: Mounting Plate For Pull With Abort Station",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "3005012",
        "description": "EOLD: End of Line Resistor & Diode Assembly",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "3006435",
        "description": "PSB-10: 10 Amp Bulk Power Supply",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "3006436",
        "description": "PSN-64: 6 Amp 4 NAC Power Supply",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "3006437",
        "description": "PSN-106: 10 Amp 6 NAC Power Supply",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "3006442",
        "description": "PSN-6 NAC RB: PSN-6 NAC Expander Replacement Board",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "3006443",
        "description": "PSN4 NAC RB: PSN4 NAC REPLACEMENT BOARD",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "3006444",
        "description": "PSB-10-PCA: PSB10 Replacement Board",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "3006445",
        "description": "PSN ENCLOSURE: PSN ENCLOSURE RED PSN/B REPLACEMENT CABINET",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "1430049",
        "description": "PC-RA:  CONVENTIONAL REMOTE ANUNCIATOR",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1430045",
        "description": "PC-2P: CONVENTIONAL PHOTOELECTRIC SMOKE DETECTOR",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1430046",
        "description": "PC-2H: CONVENTIONAL PHOTOELECTRIC SMOKE DETECTOR",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1430047",
        "description": "PC-2PH: CONVENTIONAL PHOTOELECTRIC SMOKE DETECTOR",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1430048",
        "description": "PC-2PN: CONVENTIONAL PHOTOELECTRIC SMOKE DETECTOR",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000151",
        "description": "CR-135-2: 135F ROR DUAL NORMALLY OPEN HEAT DETECTOR",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000121",
        "description": "CF-165W: 165F Heat Detector White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000122",
        "description": "CR-165W: 165F ROR Heat Detector White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000123",
        "description": "CF-200CW: 200F Heat Normally Closed White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000130",
        "description": "CR-165-C: 165F ROR Normally Closed Aluminum Finish",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000136",
        "description": "CF-135-MP: 135F Sealed Heat Detector",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000137",
        "description": "CR-135-MP: 135F ROR Sealed Heat Detector",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000138",
        "description": "CF-200-MP: 200F Sealed Heat Detector",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000139",
        "description": "CR-200-MP: 200F ROR Sealed Detector",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000140",
        "description": "CR-135W: 135F ROR Heat Detector White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000141",
        "description": "CR-200W: 200F ROR Heat Detector White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000142",
        "description": "CF-135W: 135F Heat Detector White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000143",
        "description": "CF-200W: 200F Heat Detector White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000144",
        "description": "CR-135CW: 135F ROR Normally Closed White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000145",
        "description": "CF-135CW: 135F Heat Normally Closed White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000150",
        "description": "CF-135-2: 135F Dual Normally Open Heat Detector",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000153",
        "description": "CF-165-2: 165F Dual Normally Open Heat Detector",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000154",
        "description": "CR-165-2: 165R ROR Dual Normally Open Heat Detector",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000158",
        "description": "CF-285-2: 285F Dual Normally Open Heat Detector",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000162",
        "description": "CR-165-MP: 165F ROR Sealed Detector",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000164",
        "description": "CF-285-MP: 285F Sealed Heat Detector",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000163",
        "description": "CF-165MP: Indoor Outdoor Fixed Temperature Heat Detector",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000244",
        "description": "SL-2000-P: Photoelectric Duct Smoke Detec",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1430015",
        "description": "SB-81R: Smoke Base/Relay 81ma 24V 6",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1430050",
        "description": "SM-501-P: DUCT SMOKE DETECTOR PHOTO",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1431102",
        "description": "HS-100-P: PHOTOELECTRIC PLENUM SMOKE DETECTOR",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1431109",
        "description": "SL-701 KIT: CO DUCT DET KIT W/SAMPLE TUBESRMT ANN NOR,TEST,RESET W/HN/ST",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000400",
        "description": "RMS-6T-EXP: Pull Station, S/Action, DPDT, Hex Rst Expl/Wea Proof",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000401",
        "description": "RMS-1T-WP: Pull Station, Single Action, Weatherproof Hex Reset",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000402",
        "description": "RMS-1T-WP-KL: Pull Station, Single Action, Weatherproof, Key Reset",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000403",
        "description": "RMS-1T-WP-LP: Pull Station, Dual Action, Weatherproof, Hex Reset",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000405",
        "description": "RMS-6T-EXP-WP-LP: Pull Station, D/Action, DPDT, Hex Rst Expl/Wea Proof",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000406",
        "description": "RMS-6T-EXP-WP-LP-KL: Pull Station, D/Action, DPDT, Key Rst Expl/Wea Proof",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000444",
        "description": "P32-BB: Red Indoor Surface Backbox",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000445",
        "description": "P32-DBB: Red Deep Backbox",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000447",
        "description": "P32-1T: Pull Station, Single Action, Hex Reset",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000448",
        "description": "P32-1T-LP-KL: Pull Station, Dual Action, Key Reset",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000450",
        "description": "RMS-1T-KO: Key Operated Station, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000453",
        "description": "RMS-DAH: Break Glass Pull Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000455",
        "description": "RMS-6T-WP: Pull Station, Single Action, DPDT, Hex Reset, Wproof",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000470",
        "description": "GLASS-ROD: Replacement Glass Rods",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000476",
        "description": "P32-1T-LP: Pull Station, Dual Action, Hex Reset",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000477",
        "description": "RMS-2T: Pull Station, Single Action, DPST, Hex Reset",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000478",
        "description": "RMS-6T: Pull Station, Single Action, DPDT, Hex Reset",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Initiating Devices",
        "partNumber": "1000480",
        "description": "RMS-LP: Lift & Pull Cover For Dual Action Conversion",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4871000",
        "description": "PE-HNR: Horn, wall, red, 12/24 VDC, indoor",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4871001",
        "description": "PE-HNW: Horn, wall, white, 12/24 VDC, indoor",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4871010",
        "description": "PE-LFHNR-N: Low frequency sounder, wall, red, no lettering, 24V indo",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4871011",
        "description": "PE-LFHNW-N: Low frequency sounder, wall, white, no lettering, 24V indoor",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4871012",
        "description": "PE-LFHNR: Low frequency sounder, wall, red, FIRE, 24V indoor",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4871013",
        "description": "PE-LFHNW: Low frequency sounder, wall, white, FIRE, 24V indoor",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4871014",
        "description": "PE-LFHSW: Low frequency sounder strobe, wall, white, FIRE, 110/177 cd, 24V, indoor",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4871015",
        "description": "PE-LFHSR: Low frequency sounder strobe, wall, red, FIRE, 110/177 cd, 24V, indoor",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4871002",
        "description": "PE-STR: Strobe, LED, wall, red, FIRE, clear lens, 15/30/75/110/135/185 cd, 24V, indoor",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4871003",
        "description": "PE-STW: Strobe, LED, wall, white, FIRE, clear lens, 15/30/75/110/135/185 cd, 24V, indoor",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4871004",
        "description": "PE-STRC: Strobe, LED, ceiling, red, FIRE, clear lens, 15/30/75/110/150/177 cd, 24V, indoor",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4871005",
        "description": "PE-STWC: Strobe, LED, ceiling, white, FIRE, clear lens, 15/30/75/110/150/177 cd, 24V, indoor",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4871006",
        "description": "PE-HSR: Horn strobe, LED, wall, red, FIRE, clear lens, 15/30/75/110/135/185 cd, 24V, indoor",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4871007",
        "description": "PE-HSW: Horn strobe, LED, wall, white, FIRE, clear lens, 15/30/75/110/135/185 cd, 24V, indoor",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4871008",
        "description": "PE-HSRC: Horn strobe, LED, ceiling, red, FIRE, clear lens, 15/30/75/110/150/177 cd, 24V, indoor",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4871009",
        "description": "PE-HSWC: Horn strobe, LED, ceiling, white, FIRE, clear lens, 15/30/75/110/150/177 cd, 24V, indoor",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890010",
        "description": "S-24WR: Wall Selectable Strobe, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890011",
        "description": "S-24WW: Wall Selectable Strobe, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890012",
        "description": "S-24PWR: Wall Selectable Strobe Plain, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890013",
        "description": "S-24PWW: Wall Selectable Strobe Plain, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890014",
        "description": "S24-177R: Wall Mount 177cd Strobe, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890015",
        "description": "S24-177W: Wall Mount, 177cd Strobe, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890020",
        "description": "CS-24R: Ceiling Selectable Strobe, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890021",
        "description": "CS-24W: Ceiling Selectable Strobe, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890022",
        "description": "CS-24PR: Ceiling Selectable Strobe, Plain, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890023",
        "description": "CS-24PW: Ceiling Selectable Strobe, Plain, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890030",
        "description": "HS-24WR: Wall Selectable Horn/Strobe, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890031",
        "description": "HS-24WW: Wall Selectable Horn/Strobe, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890032",
        "description": "HS-24PWR: Wall Selectable Horn/Strobe, Plain, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890033",
        "description": "HS-24PWW: Wall Selectable Horn/Strobe, Plain, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890034",
        "description": "HS24-177R: Wall mount, 177cd, Horn/Strobe, Red body",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890035",
        "description": "HS24-177W: Wall mount, 177cd, Horn/Strobe, White body",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890040",
        "description": "CHS-24R: Ceiling Selectable Horn/Strobe, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890041",
        "description": "CHS-24W: Ceiling Selectable Horn/Strobe, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890042",
        "description": "CHS-24PR: Ceiling Selectable Horn/Strobe, Plain, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890043",
        "description": "CHS-24PW: Ceiling Selectable Horn/Strobe, Plain, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "1000760",
        "description": "SASH-120: Sprinkler Alarm Horn Strobe and Sign Combination",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4710030",
        "description": "SH-120R: 120VAC Weatherproof Selectable Candela Wall Mount Horn Strobe",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4710031",
        "description": "SH-120W: 120VAC Weatherproof Selectable Candela Wall Mount Horn Strobe",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890050",
        "description": "S-24WR-WP: Wall Strobe, Red, 75cd, Weatherproof",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890051",
        "description": "S-24WW-WP: Wall Strobe, White, Weatherproof",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890052",
        "description": "S-24PWR-WP: Wall Strobe, Plain, Red, Weatherproof",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890053",
        "description": "S-24PWW-WP: Wall Strobe, Plain, White, Weatherproof",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890054",
        "description": "SLP-24WR-WP: Wall Strobe, Red, Low Profile Weatherproof",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890055",
        "description": "SLP-24WW-WP: Wall Strobe, White, Low Profile, Weatherproof",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890056",
        "description": "SLP-24PWR-WP: Wall Strobe, Plain, Red, Low Profile, Weatherproof",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890057",
        "description": "SLP-24PWW-WP: Wall Strobe, Plain, White, Low Profile, Weatherproof",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890060",
        "description": "HS-24WR-WP: Wall Horn/Strobe, Red, Weatherproof, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890061",
        "description": "HS-24WW-WP: Wall Horn/Strobe, Red, Weatherproof, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890062",
        "description": "HS-24PWR-WP: Wall Horn/Strobe, Plain, Red, Weatherproof",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890063",
        "description": "HS-24PWW-WP: Wall Horn/Strobe, Plain, White, Weatherproof",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890064",
        "description": "HSLP-24WR-WP: Wall Horn/Strobe, Red, Low Profile, Weatherproof, Fixed 75 cd",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890065",
        "description": "HSLP-24WW-WP: Wall Horn/Strobe, Red, Low Profile, Weatherproof, Fixed 75 cd",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890066",
        "description": "HSLP-24PWR-WP: Wall Horn/Strobe Plain, Red, Low Prof, Weatherproof",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890067",
        "description": "HSLP-24PWW-WP: Wall Horn/Strobe Plain, Wht, Low Prof, Weatherproof",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890100",
        "description": "CS-24WAR: Wall mount, Selectable candela,  Amber Strobe, Red body",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890101",
        "description": "CS-24WAW: Wall Selectable Amber Strobe, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890102",
        "description": "CS-24WBR: Wall Selectable Blue Strobe, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890103",
        "description": "CS-24WBW: Wall Selectable Blue Strobe, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890104",
        "description": "CS-24WGR: Wall Selectable Green Strobe, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890105",
        "description": "CS-24WGW: Wall Selectable Green Strobe, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890106",
        "description": "CS-24WRR: Wall Selectable Red Strobe, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890107",
        "description": "CS-24WRW: Wall Selectable Red Strobe, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890108",
        "description": "CCS-24AR: Ceiling Selectable Amber Strobe, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890109",
        "description": "CCS-24AW: Ceiling Selectable Amber Strobe, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890110",
        "description": "CCS-24BR: Ceiling Selectable Blue Strobe, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890111",
        "description": "CCS-24BW: Ceiling Selectable Blue Strobe, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890112",
        "description": "CCS-24GR: Ceiling Selectable Green Strobe, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890113",
        "description": "CCS-24GW: Ceiling Selectable Green Strobe, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890114",
        "description": "CCS-24RR: Ceiling Selectable Red Strobe, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890115",
        "description": "CCS-24RW: Ceiling Selectable Red Strobe, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890120",
        "description": "CHS-24AR: Wall Selectable Horn/Strobe, Amber Lens, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890121",
        "description": "CHS-24AW: Wall Selectable Horn/Strobe, Amber Lens, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890122",
        "description": "CHS-24BR: Wall Selectable Horn/Strobe, Blue Lens, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890123",
        "description": "CHS-24BW: Wall Selectable Horn/Strobe, Blue Lens, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890124",
        "description": "CHS-24GR: Wall Selectable Horn/Strobe, Green Lens, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890125",
        "description": "CHS-24GW: Wall Selectable Horn/Strobe, Green Lens, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890126",
        "description": "CHS-24RR: Wall Selectable Horn/Strobe, Red Lens, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890127",
        "description": "CHS-24RW: Wall Selectable Horn/Strobe, Red Lens, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890128",
        "description": "CCHS-24AR: Ceiling Selectable Horn/Strobe, Amber Lens, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890129",
        "description": "CCHS-24AW: Ceiling Selectable Horn/Strobe, Amber Lens, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890130",
        "description": "CCHS-24BR: Ceiling Selectable Horn/Strobe, Blue Lens, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890131",
        "description": "CCHS-24BW: Ceiling Selectable Horn/Strobe, Blue Lens, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890132",
        "description": "CCHS-24GR: Ceiling Selectable Horn/Strobe, Green Lens, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890133",
        "description": "CCHS-24GW: Ceiling Selectable Horn/Strobe, Green Lens, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890134",
        "description": "CCHS-24RR: Ceiling Selectable Horn/Strobe, Red Lens, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890135",
        "description": "CCHS-24RW: Ceiling Selectable Horn/Strobe, Red Lens, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890140",
        "description": "CS-24WAR-WP: Wall Amber Strobe, Weatherproof, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890141",
        "description": "CS-24WAW-WP: Wall Amber Strobe, Weatherproof, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890142",
        "description": "CS-24WBR-WP: Wall Blue Strobe, Weatherproof, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890143",
        "description": "CS-24WBW-WP: Wall Blue Strobe, Weatherproof, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890144",
        "description": "CS-24WGR-WP: Wall Green Strobe, Weatherproof, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890145",
        "description": "CS-24WGW-WP: Wall Green Strobe, Weatherproof, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890146",
        "description": "CS-24WRR-WP: Wall Red Strobe, Weatherproof, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890147",
        "description": "CS-24WRW-WP: Wall Red Strobe, Weatherproof, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890148",
        "description": "CSLP-24WAR-WP: Wall Amber Strobe, Low Profile, Weatherproof, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890149",
        "description": "CSLP-24WAW-WP: Wall Amber Strobe, Low Profile, Weatherproof, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890150",
        "description": "CSLP-24WBR-WP: Wall Blue Strobe, Low Profile, Weatherproof, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890151",
        "description": "CSLP-24WBW-WP: Wall Blue Strobe, Low Profile, Weatherproof, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890152",
        "description": "CSLP-24WGR-WP: Wall Green Strobe, Low Profile, Weatherproof, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890153",
        "description": "CSLP-24WGW-WP: Wall Green Strobe, Low Profile, Weatherproof, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890154",
        "description": "CSLP-24WRR-WP: Wall Red Strobe, Low Profile, Weatherproof, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890155",
        "description": "CSLP-24WRW-WP: Wall Red Strobe, Low Profile, Weatherproof, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890160",
        "description": "CHS-24AR-WP: Wall Horn/Strobe, Amber Lens, Weatherproof, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890161",
        "description": "CHS-24AW-WP: Wall Horn/Strobe, Amber Lens, Weatherproof, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890162",
        "description": "CHS-24BR-WP: Wall Horn/Strobe, Blue Lens, Weatherproof, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890163",
        "description": "CHS-24BW-WP: Wall Horn/Strobe, Blue Lens, Weatherproof, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890164",
        "description": "CHS-24GR-WP: Wall Horn/Strobe, Green Lens, Weatherproof, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890165",
        "description": "CHS-24GW-WP: Wall Horn/Strobe, Green Lens, Weatherproof, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890166",
        "description": "CHS-24RR-WP: Wall Horn/Strobe, Red Lens, Weatherproof, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890167",
        "description": "CHS-24RW-WP: Wall Horn/Strobe, Red Lens, Weatherproof, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890168",
        "description": "CHSLP-24WAR-WP: Wall Horn/Strobe, Amber Lens, Low Profile, WP, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890169",
        "description": "CHSLP-24WAW-WP: Wall Horn/Strobe, Amber Lens, Low Profile, WP, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890170",
        "description": "CHSLP-24WBR-WP: Wall Horn/Strobe, Blue Lens, Low Profile, WP, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890171",
        "description": "CHSLP-24WBW-WP: Wall Horn/Strobe, Blue Lens, Low Profile, WP, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890172",
        "description": "CHSLP-24WGR-WP: Wall Horn/Strobe, Green Lens, Low Profile, WP, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890173",
        "description": "CHSLP-24WGW-WP: Wall Horn/Strobe, Green Lens, Low Profile, WP, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890174",
        "description": "CHSLP-24WRR-WP: Wall Horn/Strobe, Red Lens, Low Profile, WP, Red Body",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890175",
        "description": "CHSLP-24WRW-WP: Wall Horn/Strobe, Red Lens, Low Profile, WP, White Body",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "1750500",
        "description": "PDC-612: 12 VDC 6 IN BELL",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "1750501",
        "description": "PDC-6 24VDC: 24 VDC 6 IN BELL",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "1750502",
        "description": "PDC-8 12VDC: 12VDC 8 IN BELL",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4870118",
        "description": "ESB-KIT-R: LED TRIM KIT, RED",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4870119",
        "description": "ESB-KIT-W: LED TRIM KIT, WHITE",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4270048",
        "description": "BBX-5R: Outdoor SL/SH Back Box Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4270049",
        "description": "BBX-5W: Outdoor SL/SH Back Box White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890250",
        "description": "AVSM-R: Sync Module Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890251",
        "description": "AVSM-W: Sync Module White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890252",
        "description": "AVBB-R: Indoor Surface Back Box, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890253",
        "description": "AVBB-W: Indoor Surface Back Box, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890254",
        "description": "WPBB-R: Outdoor Back Box, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890255",
        "description": "WPBB-W: Outdoor Back Box, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890256",
        "description": "WPLPBB-R: Low Profile Outdoor Back Box, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890257",
        "description": "WPLPBB-W: Low Profile Outdoor Back Box, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890258",
        "description": "SPKRBB-R: Speaker Outdoor Back Box, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890259",
        "description": "SPKRBB-W: Speaker Outdoor Back Box, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890260",
        "description": "CLNGBB-R: Ceiling Surface Back Box, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890261",
        "description": "CLNGBB-W: Ceiling Surface Back Box, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890262",
        "description": "HSNG-AGENT-R: Agent Bezel, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890263",
        "description": "HSNG-AGENT-W: Agent Bezel, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890264",
        "description": "HSNG-ALERT-R: Alert Bezel, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "4890265",
        "description": "HSNG-ALERT-P: Alert Bezel, White",
        "incoterms": "Miami"
      },
      {
        "category": "Explosion Proof Peripherals",
        "partNumber": "1000548",
        "description": "MPEX: MPEX Explosion Proof Manual Station",
        "incoterms": "Miami"
      },
      {
        "category": "Explosion Proof Peripherals",
        "partNumber": "1430515",
        "description": "FSEX-24PMB-MOD: BLUE EXPLOSION PROOF STROBE",
        "incoterms": "Miami"
      },
      {
        "category": "Explosion Proof Peripherals",
        "partNumber": "1430517",
        "description": "FSEX-24PMR-MOD-PT:  RED EXPLOSION PROOF STROBE",
        "incoterms": "Miami"
      },
      {
        "category": "Explosion Proof Peripherals",
        "partNumber": "1430500",
        "description": "FHEX-24 SMR: Exp-Proof Horn, Hazardous Areas (Div. 1), 24VDC",
        "incoterms": "Miami"
      },
      {
        "category": "Explosion Proof Peripherals",
        "partNumber": "1430501",
        "description": "FSEX-24PMC-MOD-PT: Exp-Proof Strobe Light, Haz Areas (Div1) 24VDC  Clear",
        "incoterms": "Miami"
      },
      {
        "category": "Explosion Proof Peripherals",
        "partNumber": "1430502",
        "description": "FSEX-CPG-HI-2-PT: Exp-Proof Strobe Light, Haz. Areas (Div. 1), 24VDC, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Explosion Proof Peripherals",
        "partNumber": "1430503",
        "description": "WMXC-4R-SB: Wall Mount Bracket",
        "incoterms": "Miami"
      },
      {
        "category": "Explosion Proof Peripherals",
        "partNumber": "1430504",
        "description": "FSEX-24PMA-MOD: Exp-Proof Strobe Light, Haz Areas (Div1) 24VDC, Amber",
        "incoterms": "Miami"
      },
      {
        "category": "Explosion Proof Peripherals",
        "partNumber": "1430506",
        "description": "CMXC-R-SB: Ceiling Mount Bracket",
        "incoterms": "Miami"
      },
      {
        "category": "Explosion Proof Peripherals",
        "partNumber": "1430507",
        "description": "PMXC-R-SB: Pendant Mounting kit Red",
        "incoterms": "Miami"
      },
      {
        "category": "Explosion Proof Peripherals",
        "partNumber": "1430508",
        "description": "DGXC-SB: Dome Guard",
        "incoterms": "Miami"
      },
      {
        "category": "Explosion Proof Peripherals",
        "partNumber": "1430509",
        "description": "SSM: Sync Module (Will synch up to 2 strobes on a circuit)",
        "incoterms": "Miami"
      }
    ]
  },
  {
    "id": "ves",
    "name": "VES",
    "logoKey": "ves",
    "products": [
      {
        "category": "Elite RS Panel",
        "partNumber": "VF0810-10",
        "description": "Elite RS-H Red  FACP 1 Loop",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF0810-40",
        "description": "Elite RS-H Gray FACP 1-Loop",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF0815-10",
        "description": "Elite RS-H Red FACP 1-Loop w/eNET",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF0815-40",
        "description": "Elite RS-H Gray FACP 1-Loop with eNET",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF0820-10",
        "description": "Elite RS-H Red FACP Two Loop",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF0820-40",
        "description": "Elite RS-H Gray FACP Two Loop",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF0825-10",
        "description": "Elite RS-H Red FACP 2-Loop w/eNET",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF0825-40",
        "description": "Elite RS-H Gray FACP 2-Loop with/ eNET",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF0850-10",
        "description": "Elite RS-A Red FACP 1 Loop",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF0850-40",
        "description": "Elite RS-A Gray FACP 1-Loop",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF0855-10",
        "description": "Elite RS-A Red FACP 1-Loop w/eNET",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF0855-40",
        "description": "Elite RS-A Gray FACP 1-Loop with eNET",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF0860-10",
        "description": "Elite RS-A Red FACP Two Loop",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF0860-40",
        "description": "Elite RS-A Gray FACP 2-Loop",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF0865-10",
        "description": "Elite RS-A Red FACP 2-Loop w/eNET",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF0865-40",
        "description": "Elite RS-A Gray FACP 2-Loop with eNET",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF1054-00",
        "description": "1 Loop Expansion Module",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF1155-00",
        "description": "Fiber Optic Converter (2 per Node)-ST Connector-single & Multi-mode fiber",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF1156-00",
        "description": "Fiber Optic Converter (2 per Node)-SC Connector-single & multi-mode fiber",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF1170-00",
        "description": "VES eNet Interface Card",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF0765-0M",
        "description": "RS Marine Battery Holder (12 AH) Kit - Black",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF1525-00",
        "description": "Elite RS Panel Key (CAT 30)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF1526-00",
        "description": "Elite RS Panel Key Lock Set (CAT 30)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel",
        "partNumber": "VF1171-00",
        "description": "16 Channel RS485 Serial I/O Interface Card",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF1172-10",
        "description": "eVIEW Serial Annunciator, Red includes surface backbox-Elite RS only",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF1172-40",
        "description": "eVIEW  Serial Annunciator, Gray-Elite RS only",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF1173-10",
        "description": "eView Flush Mount Kit, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF1173-40",
        "description": "eView Flush Mount Kit, Gray",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF2010-00",
        "description": "Analog Addressable Adjustable Fixed Heat Sensor & ROR (H)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF2015-00",
        "description": "7th Edition Photo-Optic Electronic Smoke Sensor (Type ALO-V)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF2016-00",
        "description": "7th Edition Photo-Optic Electronic Smoke Sensor (Type ACE-V)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF2017-00",
        "description": "7th Edition Photo Optic, Heat & CO Multi-Sensor (Type ACF-V)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF3001-10",
        "description": "Addressable Manual Pull Station, Single Action, CAT30 (H)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF3002-10",
        "description": "Addressable Manual Pull Station, Dual Action, CAT30 (H)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF3029-10",
        "description": "Addressable Manual Pull Station, Dual Action w/ Key Lock CAT30 (H) -",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF3030-10",
        "description": "Addressable Manual Pull Station, Dual Action w/ Hex Screw (H) -",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF3031-10",
        "description": "Addressable Manual Pull Station, Single Action w/ Hex Screw (H) -",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF3032-10",
        "description": "Addressable Manual Pull Station, Single Action w/ key Lock CAT30(H) -",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF5016-00",
        "description": "Addressable Duct Smoke Detector, w/o Relay Photoelectric (H) Type DH-100A",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF5029-00",
        "description": "Sectional Duct Sampling Tube includes 3 (2' tubes)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF6003-00",
        "description": "Short Circuit Isolator (H)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF6007-00",
        "description": "Dual Input Module (H)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF6011-00",
        "description": "Conventional Zone Module (H)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF6013-00",
        "description": "Contact Module w/Pigtails (H)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF6020-00",
        "description": "Contact Module Class A w/Mounting Plate (H)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF6021-00",
        "description": "Contact Module Class A w/Isolator & Mounting Plate (H)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF6024-00",
        "description": "Contact Module Miniature (H)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF6040-00",
        "description": "Supervised Output Module - Class A or B  (H)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF6041-00",
        "description": "Supervised Output Module with Isolator - Class A or B  (H)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF6052-00",
        "description": "Dual Relay Module Low-H (2A @ 30VDC / 0.5A @ 120 VAC)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF6053-00",
        "description": "Dual Relay Module Low-H (2A @ 30VDC / 0.5A @ 120 VAC) w/ Isolator",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF6054-00",
        "description": "Dual Relay Module High -H (8A @ 30VDC / 4.8A @ 250 VAC)",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF6055-00",
        "description": "Dual Relay Module High -H (8A @ 30VDC / 4.8A @ 250 VAC) w/ Isolator",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF6056-00",
        "description": "Current Loop Input Module - Single",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF6057-00",
        "description": "Current Loop Input Module - Dual",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF7006-00",
        "description": "Surface Trim Ring for VF7005-00 ASBL & VF7017 ASBL7",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF7013-00",
        "description": "Sensor Base 4\" (H)-7th Edition Version",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF7014-00",
        "description": "Sensor Base 6\" (H)-7th Edition Version",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF7015-00",
        "description": "Short Circuit IsolatorBase 4\"-7th Edition Version",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF7016-00",
        "description": "Short Circuit IsolatorBase 6\"-7th Edition Version",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF7017-00",
        "description": "Low Frequency Sounder Base Aux Powered - (H)-7th Edition Version",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF7018-00",
        "description": "Sounder Base Aux Powered - (H)-7th Edition Version",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF8201-00",
        "description": "Remote Red LED Indicator Annunciator - Single - Round",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF8202-00",
        "description": "Remote Red LED Indicator Annunciator - Single - Square",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "0100-10730",
        "description": "Remote Alarm Indicator LED on faceplate",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF1571-00",
        "description": "Cool Gear Serial to USB Convertor-Win 7 thru Win 8",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF1591-00",
        "description": "Loop Explorer/Panel Flashing - Programming Cable",
        "incoterms": "Miami"
      },
      {
        "category": "Elite RS Panel Peripherals",
        "partNumber": "VF9000-00",
        "description": "Handheld Programmer (TCH-B100 or AP7)",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panels",
        "partNumber": "VF1711-10",
        "description": "Elite XT+ 1 Area/Hazard Releasing Control Unit for use with Elite RS+",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panels",
        "partNumber": "VF1712-10",
        "description": "Elite XT+ 2 Area2/Hazard2 Releasing Control Unit for use with Elite RS+",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panels",
        "partNumber": "VF1810-10",
        "description": "Elite XT Conventional Releasing Panel Red 115V",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF1823-10",
        "description": "Elite XT Abort Switch Surface Mount Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF1832-10",
        "description": "Elite XT Extinguishant Disablement Switch - Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF2020-00",
        "description": "Conventional Heat Sensor 135° F (H)",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF2021-00",
        "description": "Conventional Heat Sensor 190° F (H)",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF2035-00",
        "description": "Conventional Rate of Rise Heat Detector  (Type DSC-EA)",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF2045-00",
        "description": "SOE-24V Photoelectric Smoke Detector-7th EDITION",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF2046-00",
        "description": "SOE-24H Multi-critera (Smoke & Heat) Detector -7th Edition",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF2050-00",
        "description": "Conventional 4 inch base - H",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF2051-00",
        "description": "Conventional 6 inch base - H",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF5029-00",
        "description": "Sectional Duct Sampling Tube includes 3 (2' tubes)",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF5076-00",
        "description": "Sampling Tube 10\" - H",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF5077-00",
        "description": "Sampling Tube 2.5' - H",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF5078-00",
        "description": "Sampling Tube 5' - H",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF5079-00",
        "description": "Sampling Tube 10' - H",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF5023-10",
        "description": "Duct Detector Remote Test Switch, 1 gang SS plate",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF5036-00",
        "description": "MS Series Remote annunciator / controls for Duct Detectors - Pilot, Alarm & key operated",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF3021-10",
        "description": "Manual Pull Station w/Pigtails",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF3022-10",
        "description": "Manual Pull Station w/Pigtails, Dual Action",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF3036-10",
        "description": "Conventional Manual Pull Station, Single Action, Hex Key",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF3037-10",
        "description": "Conventional Manual Pull Station, Single Action, Cat 30",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF3038-10",
        "description": "Conventional Manual Pull Station, Dual Action, Hex Key",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF3039-10",
        "description": "Conventional Manual Pull Station, Dual Action, Cat 30",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF3045-10",
        "description": "Manual Pull Station SPST w/ Terminal Blocks Dual Action Key Lock Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF3045-16",
        "description": "Manual Pull Station DPDT w/ Terminal Blocks Dual Action Key Lock Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF3045-50",
        "description": "Manual Pull Station SPST w/ Terminal Blocks Dual Action Key Lock Yellow",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF3045-56",
        "description": "Manual Pull Station DPDT w/ Terminal Blocks Dual Action Key Lock Yellow",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF3046-10",
        "description": "Manual Pull Station SPST w/ Terminal Blocks Single Action Hex Lock  Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF3048-10",
        "description": "Manual Pull Station SPST w/ Terminal Blocks Single Action Key Lock Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF3048-16",
        "description": "Manual Pull Station DPDT w/ Terminal Blocks Single Action Key Lock Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF3049-10",
        "description": "Manual Pull Station SPST w/ Terminal Blocks Dual Action Hex Lock  Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF3052-10",
        "description": "Manual Pull Station SPST w/ Pig Tails Single Action Hex Lock Weather Proof Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF3053-10",
        "description": "Manual Pull Station SPST w/ Terminal Blocks Dual Action Key Lock Weather Proof Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Releasing Panel Peripherals",
        "partNumber": "VF3054-16",
        "description": "Manual Pull Station DPDT w/ Terminal Blocks Single Action Hex Lock Explosion Proof Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4050-10",
        "description": "Strobe Only, Selectable Candela LED Strobe, Universal Mount, Red Faceplate",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4050-30",
        "description": "Strobe Only, Selectable Candela LED Strobe, Universal Mount, White Faceplate",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4056-10",
        "description": "Strobe Only, Selectable Candela LED Strobe, Universal Mount, PLAIN (no lettering), Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4056-30",
        "description": "Strobe Only, Selectable Candela LED Strobe, Universal Mount, PLAIN (no lettering), White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4051-30",
        "description": "Horn/Strobe, Selectable Candela LED Strobe, Universal Mount, White Faceplate",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4057-10",
        "description": "Horn/Strobe, Selectable Candela LED Strobe, Universal Mount, PLAIN (no lettering), Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4057-30",
        "description": "Horn/Strobe, Selectable Candela LED Strobe, Universal Mount, PLAIN (no lettering), White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4052-10",
        "description": "Outdoor Strobe Only, Selectable Candela LED Strobe, Universal Mount, Red Faceplate",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4052-30",
        "description": "Outdoor Strobe Only, Selectable Candela LED Strobe, Universal Mount, White Faceplate",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4061-10",
        "description": "Outdoor Strobe Only, Select. Candela LED Strobe, Universal Mount, PLAIN, (no letters), Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4061-30",
        "description": "Outdoor Strobe Only, Select. Candela LED Strobe, Universal Mount, PLAIN, (no letters), White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4053-10",
        "description": "Outdoor Horn/Strobe, Selectable Candela LED Strobe, Universal Mount, Red Faceplate",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4053-30",
        "description": "Outdoor Horn/Strobe, Selectable Candela LED Strobe, Universal Mount, White Faceplate",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4058-10",
        "description": "Outdoor Horn/Strobe, Selectable Candela LED Strobe, Universal Mount, PLAIN, (no letters), Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4058-30",
        "description": "Outdoor Horn/Strobe, Select. Candela LED Strobe, Universal Mount, PLAIN, (no letters), White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4055-10",
        "description": "Low Freq. Horn/Strobe, Select. Candela LED Strobe, Univer. Mount, Temporal 3/4,  PLAIN, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4055-30",
        "description": "Low Freq. Horn/Strobe, Select. Candela LED Strobe, Univer.Mount, Temporal 3/4,  PLAIN, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4059-10",
        "description": "Speaker Only, 25 or 70.7 VRMS, Universal Mount, Red Faceplate",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4059-30",
        "description": "Speaker Only, 25 or 70.7 VRMS, Universal Mount, White Faceplate",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4054-10",
        "description": "Speaker/Strobe, 25 or 70.7 VRMS, Select. Candela LED Strobe, Universal Mount, FIRE Text, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4054-30",
        "description": "Speaker/Strobe, 25 or 70.7 VRMS, Select. Candela LED Strobe, Universal Mount, FIRE Text, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4060-10",
        "description": "Speaker/Strobe, 25/70.7 VRMS, Select. Cand. LED Strobe, Univer. Mount, PLAIN (no letters), Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4060-30",
        "description": "Speaker/Strobe, 25/70.7 VRMS, Select. Cand. LED Strobe, Univer.Mount, PLAIN (no letters),White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4062-10",
        "description": "Outdoor Speaker Only, 25 or 70.7 VRMS, Universal Mount, PLAIN (no letters), Red Faceplate",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4062-30",
        "description": "Outdoor Speaker Only, 25 or 70.7 VRMS, Universal Mount, PLAIN (no letters), White Faceplate",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4063-10",
        "description": "Outdoor Speaker/Strobe, 25/70.7 VRMS, Select. Cand. LED Strobe, Univer. Mount, FIRE Text, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4063-30",
        "description": "Outdoor Speaker/Strobe, 25/70.7 VRMS, Select. Cand. LED Strobe, Univer.Mount, FIRE Text, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4064-10",
        "description": "Outdoor Speaker/Strobe, 25/70.7 VRMS, Select. Cand. LED Strobe, Univer. Mount, ALERT Text, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4064-30",
        "description": "Outdoor Speaker/Strobe, 25/70.7 VRMS, Select. Cand.LED Strobe, Univer. Mount, ALERT Text, White",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4065-10",
        "description": "Outdoor Speaker/Strobe, 25/70.7 VRMS, Select. Cand. LED Strobe, Univer. Mount, PLAIN (no letters), Red",
        "incoterms": "Miami"
      },
      {
        "category": "Conventional Notification Devices",
        "partNumber": "VF4065-30",
        "description": "Outdoor Speaker/Strobe, 25/70.7 VRMS, Select. Cand. LED Strobe, Univer. Mount, PLAIN (no letters), White",
        "incoterms": "Miami"
      }
    ]
  },
  {
    "id": "thermocable",
    "name": "Thermocable",
    "logoKey": "thermocable",
    "products": [
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1070 - 100m",
        "description": "Linear Heat Cable 68C/155F 100m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1070 - 200m",
        "description": "Linear Heat Cable 68C/155F 200m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1070 - 500m",
        "description": "Linear Heat Cable 68C/155F 500m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1070 -1000m",
        "description": "Linear Heat Cable 68C/155F 1000m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1071 - 100m",
        "description": "Linear Heat Cable 78C/178F 100m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1071 - 200m",
        "description": "Linear Heat Cable 78C/178F 200m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1071 - 500m",
        "description": "Linear Heat Cable 78C/178F 500m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1071 -1000m",
        "description": "Linear Heat Cable 78C/178F 1000m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1072 - 100m",
        "description": "Linear Heat Cable 88C/190F 100m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1072 - 200m",
        "description": "Linear Heat Cable 88C/190F 200m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1072 - 500m",
        "description": "Linear Heat Cable 88C/190F 500m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1072 -1000m",
        "description": "Linear Heat Cable 88C/190F 1000m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1073 - 100m",
        "description": "Linear Heat Cable 105C/221F 100m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1073 - 200m",
        "description": "Linear Heat Cable 105C/221F 200m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1073 - 500m",
        "description": "Linear Heat Cable 105C/221F 500m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1073 -1000m",
        "description": "Linear Heat Cable 105C/221F 1000m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1069 - 100m",
        "description": "Linear Heat Cable 185C/365F 100m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1069 - 200m",
        "description": "Linear Heat Cable 185C/365F 200m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1069 - 500m",
        "description": "Linear Heat Cable 185C/365F 500m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1069 -1000m",
        "description": "Linear Heat Cable 185C/365F 1000m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1132 - 100m",
        "description": "Linear Heat Cable 230C/446F 100m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1132 - 200m",
        "description": "Linear Heat Cable 230C/446F 200m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1132 - 500m",
        "description": "Linear Heat Cable 230C/446F 500m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1132 -1000m",
        "description": "Linear Heat Cable 230C/446F 1000m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1078 - 100m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 68C/155F 100m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1078 - 200m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 68C/155F 200m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1078 - 500m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 68C/155F 500m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1078 -1000m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 68C/155F 1000m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1079 - 100m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 78C/178F 100m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1079 - 200m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 78C/178F 200m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1079 - 500m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 78C/178F 500m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1079 -1000m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 78C/178F 1000m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1080 - 100m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 88C/190F 100m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1080 - 200m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 88C/190F 200m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1080 - 500m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 88C/190F 500m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1080 -1000m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 88C/190F 1000m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1081 - 100m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 105C/221F 100m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1081 - 200m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 105C/221F 200m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1081 - 500m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 105C/221F 500m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1081 -1000m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 105C/221F 1000m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1082 - 100m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 185C/365F 100m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1082 - 200m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 185C/365F 200m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1082 - 500m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 185C/365F 500m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1082 -1000m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 185C/365F 1000m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1133 - 100m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 230C/446F 100m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1133 - 200m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 230C/446F 200m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1133 - 500m",
        "description": "Stainless Steel Brainded Linear Heat Cable SS 230C/446F 500m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F1133 -1000m",
        "description": "Stainless Steel Brainded Linear Heat CableSS  230C/446F 1000m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection Peripherals",
        "partNumber": "A1349",
        "description": "DIGITAL INTERFACE MONITOR MODULE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection Peripherals",
        "partNumber": "A1385",
        "description": "End-of-Line Junction Box with Test Facility",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection Peripherals",
        "partNumber": "A1343",
        "description": "Junction Box with Terminals & 2 Cable Glands",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection Peripherals",
        "partNumber": "A1149-100",
        "description": "Ceiling/Wall J-Clip (50mm, 2″) - Stainless Steel",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection Peripherals",
        "partNumber": "A1362-100",
        "description": "Surface P-Clip - Aluminium",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection Peripherals",
        "partNumber": "A1329-100",
        "description": "Surface P-Clip - Stainless Steel",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection Peripherals",
        "partNumber": "A1174-100",
        "description": "Cable Trays - V-Clip - Spring Stainless Steel",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection Peripherals",
        "partNumber": "A1175-100",
        "description": "Indoor/Outdoor Standard Tiewrap",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection Peripherals",
        "partNumber": "A1176-100",
        "description": "Indoor Tiewrap High Temp. Tiewrap",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection Peripherals",
        "partNumber": "A1177-100",
        "description": "Indoor/Outdoor High Temp. Tiewrap",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection Peripherals",
        "partNumber": "C1283-100",
        "description": "Silicone Sleeves",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F3051 - 100m",
        "description": "Programmable Activation Temperature Linear Heat Cable 66C/151F to 100C/212F 100m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F3051 - 200m",
        "description": "Programmable Activation Temperature Linear Heat Cable 66C/151F to 100C/212F 200m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F3051 - 500m",
        "description": "Programmable Activation Temperature Linear Heat Cable 66C/151F to 100C/212F 500m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F3051 -1000m",
        "description": "Programmable Activation Temperature Linear Heat Cable 66C/151F to 100C/212F 1000m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F3052 - 100m",
        "description": "Programmable Activation Temperature Linear Heat Cable SS 66C/151F to 100C/212F 100m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F3052 - 200m",
        "description": "Programmable Activation Temperature Linear Heat Cable SS 66C/151F to 100C/212F 200m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F3052 - 500m",
        "description": "Programmable Activation Temperature Linear Heat Cable SS 66C/151F to 100C/212F 500m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detector",
        "partNumber": "F3052 -1000m",
        "description": "Programmable Activation Temperature Linear Heat Cable SS 66C/151F to 100C/212F 1000m",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection Peripherals",
        "partNumber": "A1388",
        "description": "Programmable Control Unit & End-of-Line Unit",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection Peripherals",
        "partNumber": "A1389",
        "description": "Programmable Control Unit",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection Peripherals",
        "partNumber": "A1470",
        "description": "End-of-Line Unit",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection Peripherals",
        "partNumber": "A1471",
        "description": "Programmable Junction Box",
        "incoterms": "Miami"
      }
    ]
  },
  {
    "id": "dgi",
    "name": "DGI",
    "logoKey": "dgi",
    "products": [
      {
        "category": "Flame Detector",
        "partNumber": "D171 SS",
        "description": "1IR + UV Fire Detectors - ATEX - FOV 100 Degrees. Detection Range 100'",
        "incoterms": "Miami"
      },
      {
        "category": "Flame Detector",
        "partNumber": "D371 SS",
        "description": "3IR + UV Fire Detectors - ATEX FOV 90 Degrees. Detection Range 200'",
        "incoterms": "Miami"
      },
      {
        "category": "Detector Accessory",
        "partNumber": "DA-001",
        "description": "Type 316 Stainless Steel Swivel Mounting Arm for D171/371 Detectors",
        "incoterms": "Miami"
      },
      {
        "category": "Detector Accessory",
        "partNumber": "DA-005",
        "description": "Weather Shield for D171/371 Detectors - Red",
        "incoterms": "Miami"
      },
      {
        "category": "Detector Accessory",
        "partNumber": "DA-006",
        "description": "Field of View Restrictor for D171/D371 Detectors - Red",
        "incoterms": "Miami"
      },
      {
        "category": "Detector Accessory",
        "partNumber": "HW-AM25-0001",
        "description": "M25 Male to ¾” Female Adapter, 316 Stainless Steel For D171/D371",
        "incoterms": "Miami"
      },
      {
        "category": "Flame Detector",
        "partNumber": "D381",
        "description": "3IR + UV Fire Detectors FOV 90 Degrees. Range 80'. Detection Range 200' - Red",
        "incoterms": "Miami"
      },
      {
        "category": "Detector Accessory",
        "partNumber": "DA-002",
        "description": "Type 316 Stainless Steel Swivel Mounting/Alignment Bracket for D381 Detector",
        "incoterms": "Miami"
      },
      {
        "category": "Detector Accessory",
        "partNumber": "DA-007",
        "description": "Weather Shield for D381  Color Red",
        "incoterms": "Miami"
      },
      {
        "category": "Detector Accessory",
        "partNumber": "HW-AM25-0002",
        "description": "M25 x ¾” Aluminum Conduit Adapter for D381 Detectors.",
        "incoterms": "Miami"
      },
      {
        "category": "Detector Accessory",
        "partNumber": "D390",
        "description": "3IR High Speed Fire Detector. Detection: 30 ft - FOV 90 deg Cable Length: 10 ft",
        "incoterms": "Miami"
      },
      {
        "category": "Detector Accessory",
        "partNumber": "DA-003-7",
        "description": "Air Purge Kit for D171/371",
        "incoterms": "Miami"
      },
      {
        "category": "Detector Accessory",
        "partNumber": "DA-003-8",
        "description": "Air Purge Kit for D181/381",
        "incoterms": "Miami"
      },
      {
        "category": "Detector Accessory",
        "partNumber": "DA-004",
        "description": "Test Lamp only for Single IR - D171, D181 and D390 Detector",
        "incoterms": "Miami"
      },
      {
        "category": "Detector Accessory",
        "partNumber": "DA-008-1",
        "description": "Remote Key Test Switch for all detectors",
        "incoterms": "Miami"
      },
      {
        "category": "Detector Accessory",
        "partNumber": "FLAME-TABLET",
        "description": "Tablet + Software for History and Fire Graphs Works with All Detectors",
        "incoterms": "Miami"
      }
    ]
  },
  {
    "id": "altronix",
    "name": "Altronix",
    "logoKey": "altronix",
    "products": [
      {
        "category": "Power Supply",
        "partNumber": "VF8260-10",
        "description": "Power Supply 3 Amps, Red (Altronix ULX series)",
        "incoterms": "Miami"
      },
      {
        "category": "Power Supply",
        "partNumber": "VF8260-20",
        "description": "Power Supply 3 Amps, Gray (Altronix ULX series)",
        "incoterms": "Miami"
      },
      {
        "category": "Power Supply",
        "partNumber": "VF8265-10",
        "description": "Power Supply 10 Amps, Red (Altronix ULX series)",
        "incoterms": "Miami"
      },
      {
        "category": "Power Supply",
        "partNumber": "VF8265-20",
        "description": "Power Supply 10 Amps, Gray (Altronix ULX series)",
        "incoterms": "Miami"
      },
      {
        "category": "Power Supply",
        "partNumber": "VF8267-10",
        "description": "Power Supply 10 amp, Red (Altronix ULX series)",
        "incoterms": "Miami"
      },
      {
        "category": "Power Supply",
        "partNumber": "VF8267-20",
        "description": "Power Supply 10 amps, Gray (Altronix ULX series)",
        "incoterms": "Miami"
      },
      {
        "category": "Power Supply",
        "partNumber": "VF8269-10",
        "description": "Power Supply, Red (Altronix ULX series)",
        "incoterms": "Miami"
      },
      {
        "category": "Power Supply",
        "partNumber": "VF8269-20",
        "description": "Power Supply, Gray (Altronix ULX series)",
        "incoterms": "Miami"
      },
      {
        "category": "Power Supply",
        "partNumber": "VF8280-10",
        "description": "NAC Booster  6.5A, 4 Output, Small Enclosure (Altronix ULADA)",
        "incoterms": "Miami"
      },
      {
        "category": "Power Supply",
        "partNumber": "VF8281-10",
        "description": "NAC Booster, 6.5 amp 4 Output, Large Enclosure (Altronix UL2ADA)",
        "incoterms": "Miami"
      },
      {
        "category": "Power Supply",
        "partNumber": "VF8282-10",
        "description": "NAC Booster, 8 amp 4 Output, Small Enclosure (Altronix UL2ADA)",
        "incoterms": "Miami"
      },
      {
        "category": "Power Supply",
        "partNumber": "VF8282-11",
        "description": "NAC Booster, 8 amp 4 Output, Small Enclosure (Altronix UL2ADA) 220V",
        "incoterms": "Miami"
      },
      {
        "category": "Power Supply",
        "partNumber": "VF8283-10",
        "description": "NAC Booster, 8 amp 4 Output, Large Enclosure (Altronix UL2ADA)",
        "incoterms": "Miami"
      },
      {
        "category": "Power Supply",
        "partNumber": "VF8283-11",
        "description": "NAC Booster, 8 amp 4 Output, Large Enclosure (Altronix UL2ADA) 220",
        "incoterms": "Miami"
      },
      {
        "category": "Power Supply",
        "partNumber": "VF8284-10",
        "description": "NAC Booster, 10 amp 4 Output, Small Enclosure (Altronix UL2ADA)",
        "incoterms": "Miami"
      },
      {
        "category": "Power Supply",
        "partNumber": "VF8284-11",
        "description": "NAC Booster, 10 amp 4 Output, Small Enclosure (Altronix UL2ADA) 220V",
        "incoterms": "Miami"
      },
      {
        "category": "Power Supply",
        "partNumber": "VF8285-10",
        "description": "NAC Booster, 10 amp 4 Output, Large Enclosure (Altronix UL2ADA)",
        "incoterms": "Miami"
      },
      {
        "category": "Power Supply",
        "partNumber": "VF8285-11",
        "description": "NAC Booster, 10 amp 4 Output, Large Enclosure (Altronix UL2ADA) 220V",
        "incoterms": "Miami"
      }
    ]
  },
  {
    "id": "fireray",
    "name": "Fireray",
    "logoKey": "fireray",
    "products": [
      {
        "category": "Beam Detection",
        "partNumber": "VF5557-00",
        "description": "Fireray One [UL]",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1010-000",
        "description": "Fireray Prism (Long Range)",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1170-000",
        "description": "Fireray Detector Adjustment Bracket",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1060-000",
        "description": "Fireray One Anti-Condensation Heater",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1140-000",
        "description": "Fireray Reflective Detector Ceiling Mount [White]",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1100-000",
        "description": "Fireray One Protective Cage",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1260-000",
        "description": "Fireray One Backbox",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "6020-300",
        "description": "Fireray Hub Reflective System (UL)",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "6030-300",
        "description": "Fireray Hub Reflective Detector (UL)",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "6080-300",
        "description": "Fireray Hub Reflective Controller (UL)",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1010-000",
        "description": "Fireray Prism (Long Range)",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1170-000",
        "description": "Fireray Detector Adjustment Bracket",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1060-000",
        "description": "Fireray Hub Reflective Anti-Condensation Heater",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1140-000",
        "description": "Fireray Reflective Detector Ceiling Mount [White]",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1100-000",
        "description": "Fireray Hub Reflective Detector Cage",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "VF5556-00",
        "description": "Fireray 3000 System [UL]",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "3000-016",
        "description": "Fireray 3000 Detector [UL]",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "3000-007",
        "description": "Fireray 3000 Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1141-000",
        "description": "Fireray 3000 Detector Ceiling Mount",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1170-000",
        "description": "Fireray Detector Adjustment Bracket",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "3000-202",
        "description": "Fireray 3000 Flush Mount Plate",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "3000-204",
        "description": "Fireray 3000 Anti-Condensation Heater",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "3000-203",
        "description": "Fireray 3000 Electrical Back box Cover Plate",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "3000-209",
        "description": "Fireray 3000 Controller Surface Mount/Semi-Flush Mount Back Box",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "3000-210",
        "description": "Fireray 3000 Semi-Flush Metal Trim Plate",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "3000-115",
        "description": "Fireray 3000 System (Ex d)",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "3000-026",
        "description": "Fireray 3000 Detector (Ex d)",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "VF5565-00",
        "description": "Fireray 5000 System [UL/FM]",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "5000-104",
        "description": "Fireray 5000 System (Long Range) [UL/FM]",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "5000-031",
        "description": "Fireray 5000 Detector  [UL/FM]",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "5000-046",
        "description": "Fireray 5000 Detector (Long Range) [UL/FM]",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "5000-003",
        "description": "Fireray 5000 Controller [UL/FM]",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1010-000",
        "description": "Fireray Prism (Long Range)",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "5000-005",
        "description": "Fireray 5000 Universal Bracket",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1170-000",
        "description": "Fireray Detector Adjustment Bracket",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "5000-204",
        "description": "Fireray 5000 Anti-Condensation Heater",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1000-018",
        "description": "Fireray 5000 Detector Protective Cage",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1000-019",
        "description": "Fireray 5000 Controller Protective Cage",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "5000-009",
        "description": "Fireray 5000 Metal Controller Back Box",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "5000-010",
        "description": "Fireray 5000 Semi-Flush Metal Trim Plate",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "5000-011",
        "description": "Fireray 5000 Detector Surface Mount Uni-Box",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "5000-012",
        "description": "Fireray 5000 Surface Mounting Plate",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "23901.01",
        "description": "Fireray Prism",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1030-000",
        "description": "Fireray Prism Wall Bracket [WT]",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1031-000",
        "description": "Fireray Prism Wall Bracket [BK]",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1040-000",
        "description": "Fireray Prism Adjustment Bracket",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1050-000",
        "description": "Fireray Prism Adjustment Bracket (Long Range)",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "5000-008",
        "description": "Fireray Prism Plate",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "5000-007",
        "description": "Fireray Prism Plate (Long Range)",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1090-000",
        "description": "Fireray Prism Heater [WT]",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "5000-205",
        "description": "Fireray Prism Heater [BK]",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1143-000",
        "description": "Fireray Prism Ceiling Mount",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1144-000",
        "description": "Fireray Prism Ceiling Mount (Long Range)",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "5000-014",
        "description": "Fireray Universal Ceiling Mount",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "1150-000",
        "description": "Fireray Commisioning and Maintenance Kit",
        "incoterms": "Miami"
      },
      {
        "category": "Beam Detection",
        "partNumber": "0209-02",
        "description": "Fireray Obscuration Test Filter",
        "incoterms": "Miami"
      }
    ]
  },
  {
    "id": "macurco",
    "name": "Macurco",
    "logoKey": "macurco",
    "products": [
      {
        "category": "Gas Detection",
        "partNumber": "70-0715-1778-6",
        "description": "CM-E1-Carbon Monoxide CO-Gas Detector for use with Fire Alarm/Burglary Control Panels",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-1361-8",
        "description": "CM-E1 Round Surface Mount Carbon Monoxide Gas Detector for use with Fire Alarm Control Panels",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0715-6468-9",
        "description": "GD-2A-Methane & Propane - Combustible Gas Detector for use with fire alarm/burglary control panels",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0005-3",
        "description": "GD-2B-Methane & Propane - Combustible Gas Detector for use with fire alarm/burglary control panels",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0715-6411-2",
        "description": "CM-E1-IAK-CM-E1/GD-2B Installation Adapter Kit",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0715-6410-1",
        "description": "CM-E1-IAK/10-CM-E1/GD-2B Installation Adapter Kit-10 Pack",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "78-2900-0046-8",
        "description": "CM-E1 Harness-CM-E1 Replacement Wire Harness-8 Pin",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-1361-2",
        "description": "CM-E1/GD-2B Round Base Housing",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0130-2",
        "description": "Gray Housing-Carbon Monoxide CO/Nitrogen Dioxide NO2 Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0135-2",
        "description": "Gray Housing-Carbon Monoxide CO/Nitrogen Dioxide NO2 Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0605-5",
        "description": "CX-6/CX-12 Carbon Monoxide CO Replacement Sensor",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0605-6",
        "description": "CX-6/CX-12 Nitrogen Dioxide NO2 Replacement Sensor",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "30-0021-1110-1",
        "description": "Field Calibration Kit Cal-Kit Macurco 2 - Includes: Calibration Case, Tygon-2 Ft, Cal Hood-Macurco Pack, 0.2LPM, Regulator (M)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0714-0531-4",
        "description": "Carbon Monoxide CO Cal Gas Aluminum Cylinder 34L 200 ppm (F)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0714-0531-3",
        "description": "Nitrogen Dioxide NO2 Cal Gas Aluminum Cylinder 34L 5 ppm (F)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "78-8150-0412-8",
        "description": "Calibration Hood used to calibrate CX, TX, OX, & RD Series Detectors",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0715-6500-9",
        "description": "Gray Housing-Carbon Monoxide CO Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0035-6",
        "description": "White Housing-Carbon Monoxide CO Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0020-0",
        "description": "Gray Housing-Carbon Monoxide CO Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0036-7",
        "description": "White Housing-Carbon Monoxide CO Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0014-3",
        "description": "Gray Housing-Carbon Monoxide CO Fixed Gas Detector & Controller (LADBS)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0014-4",
        "description": "Gray Housing-Carbon Monoxide CO Fixed Gas Detector & Controller (LADBS)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0715-4465-7",
        "description": "Carbon Monoxide CO Field Test Gas 11L 500 ppm Aerosol",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0715-3440-1",
        "description": "Carbon Monoxide CO Field Test Gas 11L 500 ppm Aerosol-12 Pack",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "30-0011-1110-2",
        "description": "Field Calibration Kit Cal-Kit Macurco 1 - Includes: Calibration Case, Tygon-2 Ft, Cal Hood-Macurco Pack, 0.2LPM, Regulator (F)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0714-8640-4",
        "description": "Carbon Monoxide CO Cal Gas Cylinder 17L 50 ppm (M)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0714-0348-2",
        "description": "Carbon Monoxide CO Cal Gas Cylinder 17L 200 ppm (M)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0715-6502-5",
        "description": "CM-6/CM-12 Carbon Monoxide CO Calibration Hood",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0004-2",
        "description": "Gray Housing-Nitrogen Dioxide NO2 Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0039-0",
        "description": "White Housing-Nitrogen Dioxide NO2 Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0022-2",
        "description": "Gray Housing-Nitrogen Dioxide NO2 Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0040-1",
        "description": "White Housing-Nitrogen Dioxide NO2 Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0605-1",
        "description": "TX-6-ND/TX-12-ND Nitrogen Dioxide NO2 Replacement Sensor",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "30-0021-1110-1",
        "description": "Field Calibration Kit Cal-Kit Macurco 2 - Includes: Calibration Case, Tygon-2 Ft, Cal Hood-Macurco Pack, 0.2LPM, Regulator (M)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0714-0531-3",
        "description": "Nitrogen Dioxide NO2 Cal Gas Aluminum Cylinder 34L 5 ppm (F)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "78-8150-0412-8",
        "description": "Calibration Hood used to calibrate CX, TX, OX, & RD Series Detectors",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0716-0802-3",
        "description": "Gray Housing-Combustible Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0037-8",
        "description": "White Housing-Combustible Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0021-1",
        "description": "Gray Housing-Combustible Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0038-9",
        "description": "White Housing-Combustible Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "30-0011-1110-2",
        "description": "Field Calibration Kit Cal-Kit Macurco 1 - Includes: Calibration Case, Tygon-2 Ft, Cal Hood-Macurco Pack, 0.2LPM, Regulator (F)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0716-1758-6",
        "description": "Hydrogen H2 Cal Gas Cylinder 34L 10% LEL (M)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0716-1759-4",
        "description": "Hydrogen H2 Cal Gas Cylinder 34L 20% LEL (M)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0716-1754-5",
        "description": "Methane CH4 Cal Gas Cylinder 34L 10% LEL (M)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0716-1755-2",
        "description": "Methane CH4 Cal Gas Cylinder 34L 20% LEL (M)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0716-1756-0",
        "description": "Propane C3H8 Cal Gas Cylinder 34L 10% LEL (M)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0716-1757-8",
        "description": "Propane C3H8 Cal Gas Cylinder 34L 20% LEL (M)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0716-0803-1",
        "description": "GD-6/GD-12 Combustible Gas EX Calibration Hood",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0600-4",
        "description": "White Housing-Carbon Dioxide CO2 Fixed Gas Detector-Range of 0-5% by vol. Auto or Manual Calibration (3 Relays)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0301-3",
        "description": "White Housing-Carbon Dioxide CO2 Fixed Gas Detector-Range of 0-5% by vol. Manual Calibration (2 Relays, 4-20mA output)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0301-2",
        "description": "White Housing-Carbon Dioxide CO2 Fixed Gas Detector & Controller, Manual Calibration Only",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0302-3",
        "description": "White Housing-Carbon Dioxide CO2 Fixed Gas Detector & Controller, Manual Calibration Only",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "30-0041-1130-2",
        "description": "Field Calibration Kit Cal-Kit Macurco 4 - Includes: Calibration Case, Tygon-2 Ft, CD-CH Cal Hood, 0.2LPM, Regulator (F)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0304-5",
        "description": "Carbon Dioxide CO2 Cal Gas Cylinder 17L 400 ppm (M)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0305-6",
        "description": "Carbon Dioxide CO2 Cal Gas Cylinder 17L 5,000 ppm (M)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0304-6",
        "description": "Carbon Dioxide CO2 Cal Gas Cylinder 17L 5% v/v (50,000 ppm) (M)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0300-1",
        "description": "Carbon Dioxide CO2 Calibration Hood work with CD-6/12MC and CD-6B",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-IAQ1-A",
        "description": "CO2 Analog Wall Mount Fixed Gas Detector-Range of 0-2,000PPM Auto Calibration",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-IAQ1-D",
        "description": "CO2 Digital Wall Mount Fixed Gas Detector-Range of 0-2,000PPM Auto Calibration",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0009-7",
        "description": "Gray Housing-Oxygen O2 Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0048-9",
        "description": "White Housing-Oxygen O2 Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0033-4",
        "description": "Gray Housing-Oxygen O2 Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0049-0",
        "description": "White Housing-Oxygen O2 Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0605-2",
        "description": "OX-6/OX-12 Oxygen O2 Replacement Sensor",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "30-0011-1110-2",
        "description": "Field Calibration Kit Cal-Kit Macurco 1 - Includes: Calibration Case, Tygon-2 Ft, Cal Hood-Macurco Pack, 0.2LPM, Regulator (F)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0061-7",
        "description": "Oxygen O2 Test Cal Gas Cylinder 34L 17% v/v (M)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "37-0472-4031-1",
        "description": "Oxygen O2 Zero Air Calibration 34L 20.9% v/v (M)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "78-8150-0412-8",
        "description": "Calibration Hood used to calibrate CX, TX, OX, & RD Series Detectors",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0008-6",
        "description": "Gray Housing-Hydrogen Sulfide H2S Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0042-3",
        "description": "White Housing-Hydrogen Sulfide H2S Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0024-4",
        "description": "Gray Housing-Hydrogen Sulfide H2S Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0045-6",
        "description": "White Housing Hydrogen Sulfide H2S Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0605-4",
        "description": "TX-6-HS/TX-12-HS Hydrogen Sulfide H2S Replacement Sensor",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "30-0021-1110-1",
        "description": "Field Calibration Kit Cal-Kit Macurco 2 - Includes: Calibration Case, Tygon-2 Ft, Cal Hood-Macurco Pack, 0.2LPM, Regulator (M)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0010-9",
        "description": "Hydrogen Sulfide H2S Cal Gas Cylinder 34L 25 ppm (F)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "78-8150-0412-8",
        "description": "Calibration Hood used to calibrate CX, TX, OX, & RD Series Detectors",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0007-5",
        "description": "Gray Housing-Ammonia NH3 Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0044-5",
        "description": "White Housing-Ammonia NH3 Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0023-3",
        "description": "Gray Housing-Ammonia NH3 Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0041-2",
        "description": "White Housing-Ammonia NH3 Fixed Gas Detector & Controller",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0605-3",
        "description": "TX-6-AM/TX-12-AM Ammonia NH3 Replacement Sensor",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "30-0052-1120-1",
        "description": "Field Calibration Kit Cal-Kit Macurco 5 - Includes: Calibration Case, Tygon-2 Ft, CX/TX-CH Cal Hood, 0.5LPM, Regulator (M)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "26-2900-0013-3",
        "description": "Ammonia NH3 Cal Gas Cylinder 34L 25 ppm (F)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "78-8150-0412-8",
        "description": "Calibration Hood used to calibrate CX, TX, OX, & RD Series Detectors",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-5354-0001-0",
        "description": "VRF Refrigerant Detector - R32 - Low Voltage, 2 Rlys, Modbus",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-5354-0001-1",
        "description": "VRF Refrigerant Detector - R32 - Line Voltage, 2 Rlys, Modbus",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-5354-0001-2",
        "description": "VRF Refrigerant Detector - R134A - Low Voltage, 2 Rlys, Modbus",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-5354-0001-3",
        "description": "VRF Refrigerant Detector - R134A - Line Voltage, 2 Rlys, Modbus",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-5354-0001-4",
        "description": "VRF Refrigerant Detector - R404A - Low Voltage, 2 Rlys, Modbus",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-5354-0001-5",
        "description": "VRF Refrigerant Detector - R404A - Line Voltage, 2 Rlys, Modbus",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-5354-0001-6",
        "description": "VRF Refrigerant Detector - R407C - Low Voltage, 2 Rlys, Modbus",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-5354-0001-7",
        "description": "VRF Refrigerant Detector - R407C - Line Voltage, 2 Rlys, Modbus",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-5354-0001-8",
        "description": "VRF Refrigerant Detector - R410A - Low Voltage, 2 Rlys, Modbus",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-5354-0001-9",
        "description": "VRF Refrigerant Detector - R410A- Line Voltage, 2 Rlys, Modbus",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-5354-0001-10",
        "description": "VRF Refrigerant Detector - R1234YF - Low Voltage, 2 Rlys, Modbus",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-5354-0001-11",
        "description": "VRF Refrigerant Detector - R1234YF - Line Voltage, 2 Rlys, Modbus",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-5354-0001-12",
        "description": "VRF Refrigerant Detector - R1234ZE - Low Voltage, 2 Rlys, Modbus",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-5354-0001-13",
        "description": "VRF Refrigerant Detector - R1234ZE - Line Voltage, 2 Rlys, Modbus",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-5354-0001-16",
        "description": "VRF Communicator - Handheld keypad that connects to the RD-VRF detectors to calibrate and customize the detectors",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-5354-0001-22",
        "description": "VRF 3 Gang Adaptor Plate",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "30-0011-1110-2",
        "description": "Field Calibration Kit Cal-Kit Macurco 1 - Includes: Calibration Case, Tygon-2 Ft, Cal Hood-Macurco Pack, 0.2LPM, Regulator (F)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "37-0662-2134-1",
        "description": "Refrigerant Cal Gas Cylinder 34L 5000 ppm R-32 (M) - Bump/Calibration",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "37-0562-2134-1",
        "description": "Refrigerant Cal Gas Cylinder 34L 5000 ppm R-134A (M) - Bump/Calibration",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "37-0672-2134-1",
        "description": "Refrigerant Cal Gas Cylinder 34L 5000 ppm R-404A (M) - Bump/Calibration",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "37-0692-2134-1",
        "description": "Refrigerant Cal Gas Cylinder 34L 5000 ppm R-410A (M) - Bump/Calibration",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-5354-0001-21",
        "description": "Calibration Hood used to calibrate RD-VRF Detectors",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0714-0315-1",
        "description": "Control Panel, 12 Analog Sensor Inputs, 3 Rlys, 2-24VDC outputs",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0015-4",
        "description": "Control Panel, 12 Analog Sensor Inputs, 3 Rlys, 2-24VDC outputs, City of LA Approved",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0032-1",
        "description": "Control Panel, 12 Analog & 87 Modbus Sensor Inputs, 3 Rlys, 2 - 24VDC outputs",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0402-3",
        "description": "Control Panel, 99 Modbus Sensor Inputs, 2-24VDC outputs, 3 Rlys, BACnet MS/TP output",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0402-4",
        "description": "Control Panel, CX-6, CM-6 & TX-6-ND Sensors only, 99 Modbus Inputs, 3 Rlys, 2-24VDC outputs, BACnet MS/TP, Title 24",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0015-5",
        "description": "Control Panel, CX-6, CM-6, TX-6-ND, CX-6 Sensors only, 99 Modbus Inputs, 3 Rlys, 2-24VDC outputs, Title 24, City of LA Approved",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0714-0315-2",
        "description": "Control Panel, works with Macurco 6-Series, 192 Modbus Inputs, 4 Rlys, BACnet IP output, 4-24VDC outputs, 3 - 4-20mA outputs",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0714-0315-3",
        "description": "Control Panel, works with Macurco 6-Series, 192 Modbus Inputs, 6 Rlys, BACnet IP output, 4-24VDC outputs, 3 - 4-20mA outputs",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0714-0315-4",
        "description": "Control Panel, works with Macurco 6-Series, 192 Modbus Inputs, 8 Rlys, BACnet IP output, 4-24VDC outputs, 3 - 4-20mA outputs",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0714-0315-6",
        "description": "Control Panel, works with Macurco 6-Series, 192 Modbus Inputs, 4 Rlys, BACnet IP output, 4-24VDC outputs, 3 - 4-20mA outputs - UL2017, Title 24, City of LA Approved",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0714-0315-7",
        "description": "Control Panel, works with Macurco 6-Series, 192 Modbus Inputs, 6 Rlys, BACnet IP output, 4-24VDC outputs, 3 - 4-20mA outputs - UL2017, Title 24, City of LA Approved",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0714-0315-8",
        "description": "Control Panel, works with Macurco 6-Series, 192 Modbus Inputs, 8 Rlys, BACnet IP output, 4-24VDC outputs, 3 - 4-20mA outputs - UL2017, Title 24, City of LA Approved",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0390-7",
        "description": "Expansion Relay Board for GBC/DVP-1200/RD-24 - 2 SPDT Relays, 250VAC, 10A Max (resistive)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0490-1",
        "description": "Remote Driver in conjunction with DVP-1200 Control Panel, 4 Expansion Slots for various I/O Options: up to 8 Rlys, 8 4-20mA outputs, 12 4-20mA inputs",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0390-6",
        "description": "Expansion Analog Output Board for RD-24 - qty 2 4-20mA outputs",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0714-0315-0",
        "description": "External Relay Box for the DVP-1200, 2 relays per RR, SPDT Relays, 250VAC, 10A Max (resistive)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0012-1",
        "description": "MRS-485-Modbus RS-485 Adapter for use with Macurco 6-Series Detectors",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0012-2",
        "description": "BRS-485 Multi-protocol RS-485 Adapter for use w/ Macurco 6-series Detectors with BMS (Modbus, BACnet, Metasys, Siemens FLN)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0714-0339-1",
        "description": "DMK-1-Duct Mount Kit-Standard 4\"x4\" Size Detectors",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0019-8",
        "description": "WHK-1-Weatherproof Enclosure Kit-Standard 4\"x4\" Size Detectors",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0227-4",
        "description": "PS-24-AC/DC Plug-in Stepdown Switching Power Supply-100-240 VAC to 24 VDC, 1 Amp",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0604-4",
        "description": "PS-24-H-AC/DC Enclosed Converter-1 Output 24V 85-264 VAC Input, 1.3 Amp",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0553-0",
        "description": "MAC6AMP-4-115VAC, 60 Hz Power Supply-6 Amp, 4 Outputs at 24VDC",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0553-2",
        "description": "MAC10AMP-4-115VAC, 60 Hz Power Supply-10 Amp, 4 Outputs at 24VDC",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "26-2900-0131-2",
        "description": "BT124 - 12vdc/4ah Battery",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "26-2900-0131-3",
        "description": "BT126 - 12vdc/7ah Battery",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "26-2900-0131-4",
        "description": "BT1212 - 12vdc/12ah Battery (Use with MAC10AMP Power Supply)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0714-0467-0",
        "description": "Female Gas Regulator, 713 connection, 0.2LPM,17L, 34L Steel Cannisters",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-0714-0468-8",
        "description": "Male Gas Regulator, 715 connection, 0.2LPM, 34L, 58L,103L Aluminum Cannisters",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0541-1",
        "description": "Male Gas Regulator, 715 connection, 0.5LPM, 34L, 58L,103L Aluminum Cannisters",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "70-2900-0541-2",
        "description": "Tygon Tubing (Price Per Foot)",
        "incoterms": "Miami"
      }
    ]
  },
  {
    "id": "protectowire",
    "name": "Protectowire",
    "logoKey": "protectowire",
    "products": [
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-155-EPC-500",
        "description": "PROTECTOWIRE, EPC, 155°F/68°C VINYL JACKET, 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-155-EPC-1000",
        "description": "PROTECTOWIRE, EPC, 155°F/68°C VINYL JACKET, 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-155-EPC-3280",
        "description": "PROTECTOWIRE, EPC, 155°F/68°C VINYL JACKET, 3281' SPOOL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-155-EPC-M-500",
        "description": "PROTECTOWIRE EPC155°F/68°C VINYL JACKET MSG WIRE,500'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-155-EPC-M-1000",
        "description": "PROTECTOWIRE, EPC, 155°F/68°C VINYL JKT, MSG WIRE, 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-190-EPC-500",
        "description": "PROTECTOWIRE, EPC, 190°F/88°C VINYL JACKET, 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-190-EPC-1000",
        "description": "PROTECTOWIRE, EPC, 190°F/88°C VINYL JACKET, 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-190-EPC-3280",
        "description": "PROTECTOWIRE, EPC, 190°F/88°C VINYL JACKET, 3281' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-190-EPC-M-500",
        "description": "PROTECTOWIRE,EPC 190°F/88°C VINYL JKT MSG WIRE 500'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-190-EPC-M-1000",
        "description": "PROTECTOWIRE EPC 190°F/88°C VINYL JKT MSG WIRE 1000'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-190-EPC-M-2500",
        "description": "PROTECTOWIRE EPC 190°F/88°C VINYL JKT MSG WIRE 2500'SPOOL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-220-EPC-500",
        "description": "PROTECTOWIRE, EPC, 220°F/105°C VINYL JACKET, 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-220-EPC-1000",
        "description": "PROTECTOWIRE, EPC, 220°F/105°C VINYL JACKET, 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-220-EPC-3280",
        "description": "PROTECTOWIRE, EPC, 220°F/105°C VINYL JACKET, 3281' SPOOL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-220-EPC-M-500",
        "description": "PROTECTOWIRE, EPC, 220°F/105°C VINYL JKT, MSG WIRE, 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-220-EPC-M-1000",
        "description": "PROTECTOWIRE, EPC, 220°F/105°C VINYL JKT, MSG WIRE, 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-220-EPC-M-2500",
        "description": "PROTECTOWIRE, EPC, 220°F/105°C VINYL JKT, MSG WIRE, 2500'SPOOL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-280-EPC-500",
        "description": "PROTECTOWIRE, EPC, 280°F/138°C VINYL JACKET, 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-280-EPC-1000",
        "description": "PROTECTOWIRE, EPC, 280°F/138°C VINYL JACKET, 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-280-EPC-3280",
        "description": "PROTECTOWIRE EPC 280°F/138°C VINYL JACKET 3281' SPOOL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-280-EPC-M-500",
        "description": "PROTECTOWIRE,EPC 280°F/138°C VINYL JKT MSG WIRE 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-280-EPC-M-1000",
        "description": "PROTECTOWIRE EPC,280°F/138°C VINYL JK ,MSG WIRE 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-280-EPC-M-2500",
        "description": "PROTECTOWIRE, EPC, 280°F/138°C VINYL JKT, MSG WIRE, 2500'SPOOL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-155-XCR-500",
        "description": "PROTECTOWIRE, XCR, 155°F/68°C FLUOROPOLYMER JACKET, 500'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-155-XCR-1000",
        "description": "PROTECTOWIRE, XCR, 155°F/68°C FLUOROPOLYMER JACKET, 1000'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-155-XCR-3280",
        "description": "PROTECTOWIRE, XCR, 155°F/68°C FLUOROPOLYMER JCKT, 3281' SPOOL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-155-XCR-M-500",
        "description": "PROTECTOWIRE XCR 155°F/680°C FLUOROPOLYMER MSGWIRE 500'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-155-XCR-M-1000",
        "description": "PROTECTOWIRE, XCR, 155°F/680°C FLUOROPOLYMR, MSGWIRE, 1000'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-155-XCR-M-2500",
        "description": "PROTECTOWIRE, XCR, 155°F/680°C FLUOROPOLYMR, MSGWIRE, 2500'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-190-XCR-500",
        "description": "PROTECTOWIRE, XCR, 190°F/88°C FLOUROPOLYMER JACKET, 500'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-190-XCR-M-1000",
        "description": "PROTECTOWIRE, TYPE XCR 190° F/ 88° C (FLUOROPOLYMER JACKET) ON MSG. WIRE (1000' COIL)",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-190-XCR-1000",
        "description": "PROTECTOWIRE, XCR, 190°F/88°C FLUOROPOLYMER JACKET, 1000'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-190-XCR-3280",
        "description": "PROTECTOWIRE, XCR, 190°F/88°C FLUOROPOLYMER JACKET, 3281' 'spool",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-220-XCR-500",
        "description": "PROTECTOWIRE, XCR, 220°F/105°C FLUOROPOLYMER JACKET, 500'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-220-XCR-1000",
        "description": "PROTECTOWIRE, XCR, 220°F/105°C FLUOROPOLYMER JACKET, 1000'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-220-XCR-3280",
        "description": "PROTECTOWIRE, XCR, 220°F/105°C FLUOROPOLYMER JCKT, 3281' SPOOL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-280-XCR-500",
        "description": "PROTECTOWIRE, XCR, 280°F/138°C FLUOROPOLYMER JACKET, 500'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-280-XCR-1000",
        "description": "PROTECTOWIRE, XCR, 280°F/138°C FLUOROPOLYMER JACKET, 1000'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-280-XCR-M-1000",
        "description": "PROTECTOWIRE, XCR, 280°F/138°C FLUORPOLYMER, MSGWIRE, 1000'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-356-XCR-500",
        "description": "PROTECTOWIRE, XCR, 356°F/180°C FLUORPOLYMER JACKET, 500'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-356-XCR-M-1000",
        "description": "PROTECTOWIRE, XCR, 356°F/180°C FLUOROPOLYMER, MSGWIRE, 1000'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-356-XCR-M-500",
        "description": "PROTECTOWIRE, XCR, 356°F/180°C FLUOROPOLYMER, MSGWIRE, 500'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-135-XLT-500",
        "description": "PROTECTOWIRE, XLT, 135°F/57°C VINYL POLYMER JACKET, 500'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-135-XLT-1000",
        "description": "PROTECTOWIRE, XLT, 135°F/57°C VINYL POLYMER JACKET, 1000'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-135-XLT-M-1000",
        "description": "PROTECTOWIRE, XLT, 135°F/57°C VINYL POLYMER JACKET,  WITH MSG WIRE, 1000'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-135-XLT-3280",
        "description": "PROTECTOWIRE, XLT, 135°F/57°C VINYL POLYMER JACKET, 3281' SPL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PLR-155R-500",
        "description": "PROTECTOWIRE, TYPE R, 155°F/68°C THERMOPLASTIC JCKT, 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PLR-155R-1000",
        "description": "PROTECTOWIRE, TYPE R, 155°F/68°C THERMOPLASTIC JKT, 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PLR-190R-500",
        "description": "PROTECTOWIRE TYPE R 155°F/88°C THERMOPLASTIC JKT 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PLR-190R-1000",
        "description": "PROTECTOWIRE, TYPE R, 155°F/88°C THERMOPLASTIC JKT, 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-155-EPC-500",
        "description": "PROTECTOWIRE, CTI, 155°F/68°C VINYL JACKET, 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-155-1000",
        "description": "PROTECTOWIRE, CTI, 155°F/68°C VINYL JACKET, 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-155-3280",
        "description": "PROTECTOWIRE, CTI, 155°F/68°C VINYL JACKET, 3281' SPOOL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-190-500",
        "description": "PROTECTOWIRE, CTI, 190°F/88°C VINYL JACKET, 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-LSZH-135-1000",
        "description": "PROTECTOWIRE, PHSC-LSZH LOW SMOKE ZERO HALOGEN JACKET, 135°F/57°C OFF WHITE JACKET 1000FT SPOOL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-190-1000",
        "description": "PROTECTOWIRE, CTI, 190°F/88°C VINYL JACKET, 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-LSZH-155-1000",
        "description": "PROTECTOWIRE, PHSC-LSZH LOW SMOKE ZERO HALOGEN JACKET, 155°F/68°C OFF WHITE JACKET 1000FT SPOOL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-190-LSZH-M-1000",
        "description": "PROTECTOWIRE, CTI, 190°F/88°C FOR LOW SMOKE ZERO HALOGEN WITH MESSENGER WIRE, 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-220-500",
        "description": "PROTECTOWIRE, CTI, 220°F/105°C VINYL JACKET, 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-280-500",
        "description": "PROTECTOWIRE, CTI, 280°F/138°C VINYL JACKET, 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-356-EPC-500",
        "description": "PROTECTOWIRE, CTI, 356°F/180°C VINYL JACKET, 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-155X-500",
        "description": "PROTECTOWIRE, CTI-X, 155°F/68°C FLUOROPOLYMER JKT, 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-155X-1000",
        "description": "PROTECTOWIRE, CTI-X, 155°F/68°C FLUOROPOLYMER JKT, 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-190X-500",
        "description": "PROTECTOWIRE CTI,-X 190°F/88°C FLUOROPLYMER JACKET 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-190X-1000",
        "description": "PROTECTOWIRE CTI,-X 190°F/88°C FLUOROPLYMER JACKET 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-220X-500",
        "description": "PROTECTOWIRE, CTI, -X, 220°F105°C FLOUROPOLYMER JKT, 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-220X-1000",
        "description": "PROTECTOWIRE, CTI, -X, 220°F105°C FLOUROPOLYMER JKT, 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-220X-3280",
        "description": "PROTECTOWIRE, CTI, -X, 220°F105°C FLOUROPOLYMER JKT, 3281' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-280X-500",
        "description": "PROTECTOWIRE CTI,-X,280° F138°C FLOUROPOLYMER JKT 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-280X-1000",
        "description": "PROTECTOWIRE CTI,-X,280° F138°C FLOUROPOLYMER JKT 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-356-XCR-500",
        "description": "PROTECTOWIRE, CTI, -X, 356°F180°C FLOUROPOLYMER JKT, 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-356X-1000",
        "description": "PROTECTOWIRE, CTI, -X, 356°F180°C FLOUROPOLYMER JKT, 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-356-EPC-1000",
        "description": "PROTECTOWIRE, EPC, 356°F/180°C VINYL JACKET, 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PLR-500CR-1000",
        "description": "PROTECTOWIRE, TYPER, 560°F/260°C THERMOPLASTIC JKT, 1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-135XLT-500",
        "description": "PROTECTOWIRE, TYPE CTI-XLT, 135° PROTECTOWIRE      500FT SPOOL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PHSC-356-EPC-500",
        "description": "PROTECTOWIRE, EPC, 356°F/180°C VINYL JACKET, 500' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-135XLT-3281",
        "description": "PROTECTOWIRE, TYPE CTI-XLT, 135° PROTECTOWIRE     3281FT SPOOL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-135XLT-1000",
        "description": "PROTECTOWIRE, TYPE CTI-XLT, 135° PROTECTOWIRE     1000FT SPOOL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PLR-500-XCR-1000",
        "description": "PROTECTOWIRE,TYPER,560�F/260�C THERMOPLASTIC JKT,1000' COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI-155-XCR-M-500",
        "description": "PROTECTOWIRE,CTI-X,155°F/68°C         FLUOROPOLYMER,MSGWIRE,500'COIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTM-230E",
        "description": "INTERFACE MODULE, CTI, W/LEDS IN NEMA 4X(IP66) ENCLOSURE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTM-530",
        "description": "INTERFACE MODULE, CTI, W/LCD & PROTECTORWIRE   NAVIAGTION PTS",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTM-230",
        "description": "INTERFACE MODULE, CTI, W/LEDS LESS ENCLOSURE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTM-530E",
        "description": "INTERFACE MODULE, CTI, W/NEMA4X PROTECTORWIRE  (IP66)ENCLOSURE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTM-530E-I",
        "description": "INTERFACE MODULE, CTI, ISB ENCL PROTECTORWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "EN-534",
        "description": "ENCL, NEMA-4X-IP66, W/MOUNTING PROTECTOWIRE      HARDWARE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PIM-120",
        "description": "MINI INTERFACE MODULE, W/LEDs NO ENCLOSURE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PIM-120E",
        "description": "MINI INTERFACE MODULE, W/LEDs IN NEMA 4X (IP66) ENCLOSURE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PIM-230E",
        "description": "Interface Module w/LEDs in NEMA 4X (IP66) Enclosure",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PIM-120E-I",
        "description": "MINI INTERFACE MODULE, W/LEDs AND ISB IN NEMA 4X (IP66) ENCLOSURE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PIM-230",
        "description": "Interface Module w/LEDS less Enclosure",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PIM-530",
        "description": "INTERFACE MODULE, W/LCD & NAVI PROTECTOWIRE     W/O ENCLOSURE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PIM-530E",
        "description": "INTERFACE MODULE, W/LCD & NAVI PROTECTOWIRE   W/NEMA 4X ENCL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PIM-530E-I",
        "description": "INTERFACE MODULE, W/LCD & NAVI PROTECTOWIRE  & ISB IN NEMA 4X",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "ZB-4-QC-MP",
        "description": "ENCL, MP, W/COMP TERMINALS PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "ELR-4-QC-MP",
        "description": "ENCLOSURE, MP EOL, W/4.7K RES PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "SR-502",
        "description": "CONNECTOR, STRAIN RELIEF PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "SR-502-N",
        "description": "CONNECTOR, STRAIN RELIEF PROTECTOWIRE      NON METALLIC",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PWSC",
        "description": "SPLICING CONNECTORS (10 PACK) PROTECTORWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PWSK-4",
        "description": "KIT, SPLICING CONNECTOR PROTECTOWIRE, FIELD SERVICEABLE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "SFTS",
        "description": "SEALANT TAPE, 1\" X 10' PROTECTORWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "#35 WHITE",
        "description": "SPLICING TAPE, WHITE PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "#35 RED",
        "description": "SPLICING TAPE, RED PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "#35 BLUE",
        "description": "SPLICING TAPE, BLUE PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "WAW-N",
        "description": "CORNER CLIPS, NYLON, WHITE PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "WAW-P",
        "description": "CORNER CLIPS, POLYPROPLENE, CLR PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "OHS-1",
        "description": "CLIPS, LINE PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "OHS-SS",
        "description": "CLIPS, LINE, SS PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "BC-2",
        "description": "CLAMP ASSEMBLY, BEAM, STEEL PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "BC-3P",
        "description": "CLAMP ASSEMBLY, BEAM, IRON ZINC PROTECTOWIRE   W/PROLYPRO CLIP",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "BC-3N",
        "description": "CLAMP ASSEMBLY, BEAM, IRON ZINC PROTECTOWIRE     W/NYLON CLIP",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "RMC-2",
        "description": "L-BRACKET,SS,RIM SEAL TYPE PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "TR-5G",
        "description": "STANDOFF, INSULATED PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "EMS-A-CO",
        "description": "CABLE MOUNT PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "TM-T",
        "description": "CABLE TIE PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "MS-3091T",
        "description": "RETRACTABLE CABLE, 99FT PROTECTORWIRE   PHSC.CTI, & PLR",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "SR-505",
        "description": "STRAIN RELIEF CONNECTOR PROTECTOWIRE    USE W/MS-3091T",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "HPC-2",
        "description": "MOUNTING CLIP SINGLE PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CC-2N",
        "description": "CLIP, CABLE TRAY, .06\" TO .16\" PROTECTORWIRE W/ISB & NEM4XENC",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CC-2W",
        "description": "CLIP, CABLE TRAY, .16\" TO .25\" PROTECTORWIRE W/ISB & NEM4XENC",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PM-3A",
        "description": "PIPE MOUNTING STRAPS, 3/4\"-2\" PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PM-3B",
        "description": "PIPE MOUNTING STRAPS PROTECTOWIRE  2-1/2\" TO 3-1/2\"",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PM-3C",
        "description": "PIPE MOUNTING STRAPS, 4\" TO 6\" PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "TR-4A",
        "description": "EYEBOLT PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "TR-24",
        "description": "TURNBUCKLE PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "MFL-92",
        "description": "FAULT LOCATOR SYSTEM PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "APL-90",
        "description": "METER ADAPTER, ALARM PT LOCATOR PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "SPL-2M",
        "description": "SPARE INSTALLATIONS, 1500'SPOOL PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PWTX-200",
        "description": "EXT WIRE, PVC THERMOCOUPL, 22AWG PROTECTOWIRE       200FT (60M)",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PWTX-500",
        "description": "EXT WIRE, PVC THERMOCOUPL, 22AWG PROTECTOWIRE  500FT (152M)",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTIC",
        "description": "SPLICING KIT, CTI, W/CONNECTORS PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "TCTB-NT",
        "description": "TERM BLK, W/INTEGRATED TESTJACK PROTECTORWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PTS-8204",
        "description": "CONTROLLER, FIBER OPTIC, 2 CH PROTECTOWIRE         4KM RANGE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PTS-8206",
        "description": "CONTROLLER, FIBER OPTIC, 2 CH PROTECTOWIRE         6KM RANGE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PROTECTOWIRE OPTION A",
        "description": "INTEGRATED MODBUS, TCP/IP PROTECTOWIRE      PROTOCOL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PWC-2000",
        "description": "CONNECTOR, E2000 APC, 8° ANGLED PROTECTOWIRE       16' PIGTAIL",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "JB-2S",
        "description": "ENCL, INTEGRAL STRAIN RELIEF & PROTECTOWIRE      SPLICE TRAY",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PFS-554-FR",
        "description": "SENSOR CABLE, W/INTL SS CORE PROTECTOWIRE        PER METER",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PFS-654-MF",
        "description": "SENSOR CABLE, METAL FREE SENSOR PROTECTOWIRE         PER METER",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PWS",
        "description": "SPLICING SLEEVES (10 PACK) PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "500128",
        "description": "SNAP BUTTON, WAW PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "ZB-HD-4-QC",
        "description": "ENCL, NEMA-4X, JIC, FIBERGLASS PROTECTOWIRE, COMPRESSION TERMS",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PTS-8208A",
        "description": "CONTROLLER, FIBER OPTIC, 2CH, 8km PROTECTOWIRE   W/MODBUS INTERF",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "SRP-4X4",
        "description": "CTRL PANEL, 4ZONE, ALARM/RELEASE PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "CTI CAL KIT",
        "description": "Kit includes TMQSS-125U-6 Temperature Probe & SMPW-T-M Thermocouple Jumper",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "RB-4",
        "description": "ALARM RELAY BOARD INCLUDES 4 PROTECTOWIRE SPDT RELAYS",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "ELR-HD-4-QC-ETS",
        "description": "ENCL EOL, NEMA-4X, W/ EXTERNAL PUSH BUTTONTEST SWITCH PROTECTORWIRE       & 4.75 RES",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "ELR-HD-U",
        "description": "ENCL EOL, NEMA-4X, W/TEST SWITCH PROTECTORWIRE       & 4.75 RES",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "FS2004-120-GC-H3CLL3-EN4R",
        "description": "FS 2000 PANEL FOR PHSC LINEAR HEAT DETECTOR  NEMA 1 RED ENCLOSURE  (3) DPDT ALARM RELAY PER ZONE  (3) OPTION H=ISB FOR CLASSIFIED  HAZARD-1 SPARE INIATING CIRCUIT",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "JD-1",
        "description": "LINE CLIP 304 SS WITH 1/4\"HOLE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "TR-4A-S",
        "description": "EYEBOLT,STAINLESS 304",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "TR-24-S",
        "description": "TURNBUCKLE,SS W/ALUMINUM BODY",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "SG-42SK1",
        "description": "PULL STATION, SPST, DUAL ACTION PULL STATION",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "RMC-3",
        "description": "L-BRACKET,SS,RIM SEAL TYPE PROTECTOWIRE",
        "incoterms": "Miami"
      },
      {
        "category": "Linear Heat Detection",
        "partNumber": "PTS-8208",
        "description": "CONTROLLER,FIBER OPTIC,2 CH PROTECTOWIRE         8KM RANGE",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "PW-R-GAS-FLAMMABLE",
        "description": "Lithium off-gas & Combustible Gas Sensor w/3 Relays (ETL 2075)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "PW-AX-DIN-Clip",
        "description": "DIN Rail Mounting Clips (2)",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "PW-AX-GAS-BUMP",
        "description": "Bump test adapter for gas sensors",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "PW-AX-MAGNET",
        "description": "2 Magnets with 3M Self Adhesive for sensors or base unit.",
        "incoterms": "Miami"
      },
      {
        "category": "Gas Detection",
        "partNumber": "PW-AX-LEAK-CLIP",
        "description": "Leak Cable Clips",
        "incoterms": "Miami"
      }
    ]
  },
  {
    "id": "statx",
    "name": "Stat-X",
    "logoKey": "statx",
    "products": [
      {
        "category": "Aerosol Suppression",
        "partNumber": "15100",
        "description": "Stat-X, 30E",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15110",
        "description": "Stat-X, 60E – specific applications only",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15090",
        "description": "Stat-X, 15E",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15120",
        "description": "Stat-X, 100E",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15130",
        "description": "Stat-X, 250E",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15530",
        "description": "Stat-X, 250ME",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15140",
        "description": "Stat-X, 500E",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15150",
        "description": "Stat-X, 1000E",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15550",
        "description": "Stat-X, 1000ME",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15160",
        "description": "Stat-X, 1500E",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15170",
        "description": "Stat-X, 2500E",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15111",
        "description": "Stat-X, 60ME – specific applications only",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15100",
        "description": "Stat-X, 30E",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15100",
        "description": "Stat-X, 30E",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15100",
        "description": "Stat-X, 30E",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15100",
        "description": "Stat-X, 30E",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15120",
        "description": "Stat-X, 100E",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15100",
        "description": "Stat-X, 30E",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15100",
        "description": "Stat-X, 30E",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15100",
        "description": "Stat-X, 30E",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "17001",
        "description": "Upgrade for CNC Application (for 100E, 250E, 500E only)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "16050",
        "description": "Evacuation sign",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "16052",
        "description": "Isolate switch sign",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "16055",
        "description": "Abort switch sign",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "16100",
        "description": "Evacuate sign",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "16103",
        "description": "Discharge Station",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "16104",
        "description": "Event sign, small",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "16105",
        "description": "Event sign, large",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18001",
        "description": "Mounting Bracket, 2” - 30/60/60M",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18002",
        "description": "Mounting Bracket, 2” - 30E/60E/60ME, Single Mount",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18005",
        "description": "Mounting Bracket, 3” - 100E/250ME",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18006",
        "description": "Mounting Bracket, 3” Heavy Duty - 100E/250ME",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18010",
        "description": "Mounting Bracket, 5” - 250E/500E/1000ME",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18011",
        "description": "Mounting Bracket, 5” Heavy Duty - 250E/500E/1000ME",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18015",
        "description": "Mounting Bracket, 8” - 1000E/1500E/2500E",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18016",
        "description": "Mounting Bracket, 8” Heavy Duty - 1000E/1500E/2500E",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18210",
        "description": "External Mounting Bracket, 5” - 250E/500E/1000ME",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18215",
        "description": "15E Din Rail Bracket Kit (fits 15E unit)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18216",
        "description": "15E Din Rail Magnetic Bracket Kit (fits 15E unit)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18216",
        "description": "15E Din Rail Magnetic Bracket Kit (fits 15E unit)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18274",
        "description": "8” Penetrator bracket for ceiling/roof mount (double wall) with sunshield",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18275",
        "description": "8” Penetrator bracket for wall mount",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18283 A",
        "description": "Standard unit clamp (default with PN 18275)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18283 B",
        "description": "Sunshield unit clamp (default with PN 18274)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18288",
        "description": "Rupture diaphragm (replacement Mylar membrane)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14640",
        "description": "Assembly, Adapter w/Cable Gland ¾ NPT to metric",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14810",
        "description": "Protective cover, 2” (30E, 60E)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14811",
        "description": "Protective cover, 3” (100E)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14812",
        "description": "Protective cover, 5” (250E, 500E)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14813",
        "description": "Protective cover, 8” (1000E, 1500E, 2500E)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11880",
        "description": "Stat-X EX, 30E, CLI DIV2/Zone 2, Brass, 3/4\" NPT   (minimum order 20 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11890",
        "description": "Stat-X EX, 60E, CLI DIV2/Zone 2, Brass, 3/4\" NPT   (minimum order 10 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11900",
        "description": "Stat-X EX, 60ME, CLI DIV2/Zone 2, Brass, 3/4\" NPT (minimum order 10 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11910",
        "description": "Stat-X EX, 100E, CLI DIV2/Zone 2, Brass, 3/4\" NPT (minimum order 10 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11920",
        "description": "Stat-X EX, 250E, CLI DIV2/Zone 2, Brass, 3/4\" NPT (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11930",
        "description": "Stat-X EX, 500E, CLI DIV2/Zone 2, Brass, 3/4\" NPT' (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11940",
        "description": "Stat-X EX, 1000E, CLI DIV2/Zone 2, Brass, 3/4\" NPT (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11950",
        "description": "Stat-X EX, 1500E, CLI DIV2/Zone 2, Brass, 3/4\" NPT (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11960",
        "description": "Stat-X EX, 2500E, CLI DIV2/Zone 2, Brass,  3/4\" NPT (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11885",
        "description": "Stat-X EX, 30E, CLI DIV2/Zone 2, 316SS, 3/4 \"NPT (minimum order 10 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11895",
        "description": "Stat-X EX, 60E, CLI DIV2/Zone 2, 316SS, 3/4\" NPT (minimum order 10 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11905",
        "description": "Stat-X EX, 60ME, CLI DIV2/Zone 2, 316SS, 3/4\" NPT (minimum order 10 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11915",
        "description": "Stat-X EX, 100E, CLI DIV2/Zone 2, 316SS, 3/4\" NPT (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11925",
        "description": "Stat-X EX, 250E, CLI DIV2/Zone 2, 316SS, 3/4\" NPT  (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11935",
        "description": "Stat-X EX, 500E, CLI DIV2/Zone 2, 316SS, 3/4\" NPT (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11945",
        "description": "Stat-X EX, 1000E, CLI DIV2/Zone 2, 316SS, 3/4\" NPT (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11955",
        "description": "Stat-X EX, 1500E, CLI DIV2/Zone 2, 316SS, 3/4\" NPT (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11965",
        "description": "Stat-X EX, 2500E, CLI DIV2/Zone 2, 316SS, 3/4\" NPT (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11880M",
        "description": "Stat-X EX, 30E, CLI DIV2/Zone 2, Brass, M25 (minimum order 20 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11890M",
        "description": "Stat-X EX, 60E, CLI DIV2/Zone 2, Brass, M25 (minimum order 10 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11900M",
        "description": "Stat-X EX, 60ME, CLI DIV2/Zone 2, Brass, M25 (minimum order 10 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11910M",
        "description": "Stat-X EX, 100E, CLI DIV2/Zone 2, Brass, M25 (minimum order 10 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11920M",
        "description": "Stat-X EX, 250E, CLI DIV2/Zone 2, Brass, M25 (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11930M",
        "description": "Stat-X EX, 500E, CLI DIV2/Zone 2, Brass, M25 (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11940M",
        "description": "Stat-X EX, 1000E, CLI DIV2/Zone 2, Brass, M25 (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11950M",
        "description": "Stat-X EX, 1500E, CLI DIV2/Zone 2, Brass, M25 (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11960M",
        "description": "Stat-X EX, 2500E, CLI DIV2/Zone 2, Brass, M25 (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11885M",
        "description": "Stat-X EX, 30E, CLI DIV2/Zone 2, 316SS, M25 (minimum order 10 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11895M",
        "description": "Stat-X EX, 60E, CLI DIV2/Zone 2, 316SS, M25 (minimum order 10 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11905M",
        "description": "Stat-X EX, 60ME, CLI DIV2/Zone 2, 316SS, M25 (minimum order 10 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11915M",
        "description": "Stat-X EX, 100E, CLI DIV2/Zone 2, 316SS, M25 (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11925M",
        "description": "Stat-X EX, 250E, CLI DIV2/Zone 2, 316SS, M25 (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11935M",
        "description": "Stat-X EX, 500E, CLI DIV2/Zone 2, 316SS, M25 (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11945M",
        "description": "Stat-X EX, 1000E, CLI DIV2/Zone 2, 316SS, M25 (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11955M",
        "description": "Stat-X EX, 1500E, CLI DIV2/Zone 2, 316SS, M25 (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "11965M",
        "description": "Stat-X EX, 2500E, CLI DIV2/Zone 2, 316SS, M25 (minimum order 5 pcs.)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "16050",
        "description": "Evacuation sign",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "16052",
        "description": "Isolate switch sign",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18001",
        "description": "Mounting Bracket, 2\" - 30EX/60EX/60MEX",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18002",
        "description": "Mounting Bracket, 2” – 30EX/60EX/60MEX, Single Mount",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18005",
        "description": "Mounting Bracket, 3” - 100EX",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18006",
        "description": "Mounting Bracket, 3” Heavy Duty - 100EX",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18010",
        "description": "Mounting Bracket, 5” - 250EX/500EX",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18011",
        "description": "Mounting Bracket, 5” Heavy Duty - 250EX/500EX",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18015",
        "description": "Mounting Bracket, 8” - 1000T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18016",
        "description": "Mounting Bracket, 8” Heavy Duty - 1000EX/1500EX/2500EX",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14810",
        "description": "Protective cover, 2” (30E, 60E)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14811",
        "description": "Protective cover, 3” (100E)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14812",
        "description": "Protective cover, 5” (250E, 500E)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14813",
        "description": "Protective cover, 8” (1000E, 1500E, 2500E)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14692",
        "description": "SOLO Ultra (includes 10k resistors)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14592",
        "description": "Stat-X System Verification Device (10 pcs)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15300",
        "description": "Stat-X, 30T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15310",
        "description": "Stat-X, 60T – specific applications only",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15311",
        "description": "Stat-X, 60MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15410",
        "description": "Stat-X, 100T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15510",
        "description": "Stat-X, 250T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15511",
        "description": "Stat-X, 250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15610",
        "description": "Stat-X, 500T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15711",
        "description": "Stat-X, 1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15710",
        "description": "Stat-X, 1000T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15300",
        "description": "Stat-X, 30T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15310",
        "description": "Stat-X, 60T – specific applications only",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15311",
        "description": "Stat-X, 60MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15410",
        "description": "Stat-X, 100T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15510",
        "description": "Stat-X, 250T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15511",
        "description": "Stat-X, 250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15610",
        "description": "Stat-X, 500T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15711",
        "description": "Stat-X, 1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15710",
        "description": "Stat-X, 1000T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "16103",
        "description": "Discharge Station",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "16104",
        "description": "Event sign, small",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "16105",
        "description": "Event sign, large",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18001",
        "description": "Mounting Bracket, 2” - 30T/60T/60MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18002",
        "description": "Mounting Bracket, 2” - 30T/60T/60MT, Single Mount",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18005",
        "description": "Mounting Bracket, 3” - 100T/250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18006",
        "description": "Mounting Bracket, 3” Heavy Duty - 100T/250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18010",
        "description": "Mounting Bracket, 5” - 250T/500T/1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18011",
        "description": "Mounting Bracket, 5” Heavy Duty - 250T/500T/1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18201",
        "description": "2” Bracket – External Mount (fits 30T, 30E, 60T, 60MT, and 60E units)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18205",
        "description": "External Mounting Bracket, 3\" - 100T/250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18015",
        "description": "Mounting Bracket, 8” - 1000T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18016",
        "description": "Mounting Bracket, 8” Heavy Duty - 1000T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20142",
        "description": "Head, Thermal, 158°F/70°C, AL",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20143",
        "description": "Head, Thermal, 203F/95°C, AL",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20144",
        "description": "Head, Thermal, 254°F/123°C, AL",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20152",
        "description": "Head, Thermal, 158°F/70°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20153",
        "description": "Head, Thermal, 203°F/95°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20154",
        "description": "Head, Thermal, 254°F/123°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20152",
        "description": "Head, Thermal, 158°F/70°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20153",
        "description": "Head, Thermal, 203°F/95°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20154",
        "description": "Head, Thermal, 254°F/123°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20105",
        "description": "T/M head, 203°F/95°C, Vertical Pull, Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20106",
        "description": "T/M Head, 254°F/123°C, Horizontal Pull, Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20107",
        "description": "T/M head, 254°F/123°C, vertical pull, alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20112",
        "description": "T/M Head, 158°F/70°C, Horizontal Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20113",
        "description": "T/M head, 158°F/70°C, vertical pull, brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20115",
        "description": "T/M Head, 203°F/95°C, Vertical Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20114",
        "description": "T/M Head, 203°F/95°C, Horizontal Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20117",
        "description": "T/M Head, 254°F/123°C, Vertical Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20102",
        "description": "T/M Head, 158F/70C, Horizontal Pull, Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20103",
        "description": "T/M Head, 158F/70C, Vertical Pull, Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20104",
        "description": "T/M Head, 203F/95C, Horizontal Pull,Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20116",
        "description": "T/M Head, 254°F/123°C, Horizontal Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20105",
        "description": "T/M head, 203°F/95°C, Vertical Pull, Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20106",
        "description": "T/M Head, 254°F/123°C, Horizontal Pull, Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20107",
        "description": "T/M head, 254°F/123°C, vertical pull, alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20112",
        "description": "T/M Head, 158°F/70°C, Horizontal Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20113",
        "description": "T/M head, 158°F/70°C, vertical pull, brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20115",
        "description": "T/M Head, 203°F/95°C, Vertical Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20114",
        "description": "T/M Head, 203°F/95°C, Horizontal Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20117",
        "description": "T/M Head, 254°F/123°C, Vertical Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20102",
        "description": "T/M Head, 158F/70C, Horizontal Pull, Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20103",
        "description": "T/M Head, 158F/70C, Vertical Pull, Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20104",
        "description": "T/M Head, 203F/95C, Horizontal Pull,Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20116",
        "description": "T/M Head, 254°F/123°C, Horizontal Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18220",
        "description": "Thermal Switch Clip Assembly, 2”, NO (normally open – discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18221",
        "description": "Thermal Switch Clip Assembly, 3”, NO (normally open – discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18222",
        "description": "Thermal Switch Clip Assembly, 5”, NO  (normally open – discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18225",
        "description": "Thermal Switch Clip Assembly, 2”, NC (normally closed - discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18226",
        "description": "Thermal Switch Clip Assembly, 3”, NC (normally closed - discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18227",
        "description": "Thermal Switch Clip Assembly, 5”, NC (normally closed - discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18223",
        "description": "Thermal Switch Clip Assembly, 8”, NO  (normally open – discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18228",
        "description": "Thermal Switch Clip Assembly, 8”, NC (normally closed - discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18001",
        "description": "Mounting Bracket, 2” - 30T/60T/60MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18002",
        "description": "Mounting Bracket, 2” - 30T/60T/60MT, Single Mount",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18005",
        "description": "Mounting Bracket, 3” - 100T/250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18006",
        "description": "Mounting Bracket, 3” Heavy Duty - 100T/250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18010",
        "description": "Mounting Bracket, 5” - 250T/500T/1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18011",
        "description": "Mounting Bracket, 5” Heavy Duty - 250T/500T/1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18201",
        "description": "2” Bracket – External Mount (fits 30T, 30E, 60T, 60MT, and 60E units)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18205",
        "description": "External Mounting Bracket, 3\" - 100T/250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18015",
        "description": "Mounting Bracket, 8” - 1000T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18016",
        "description": "Mounting Bracket, 8” Heavy Duty - 1000T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20142",
        "description": "Head, Thermal, 158°F/70°C, AL",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20143",
        "description": "Head, Thermal, 203F/95°C, AL",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20144",
        "description": "Head, Thermal, 254°F/123°C, AL",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20152",
        "description": "Head, Thermal, 158°F/70°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20153",
        "description": "Head, Thermal, 203°F/95°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20154",
        "description": "Head, Thermal, 254°F/123°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20152",
        "description": "Head, Thermal, 158°F/70°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20153",
        "description": "Head, Thermal, 203°F/95°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20154",
        "description": "Head, Thermal, 254°F/123°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18220",
        "description": "Thermal Switch Clip Assembly, 2”, NO (normally open – discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18221",
        "description": "Thermal Switch Clip Assembly, 3”, NO (normally open – discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18222",
        "description": "Thermal Switch Clip Assembly, 5”, NO  (normally open – discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18225",
        "description": "Thermal Switch Clip Assembly, 2”, NC (normally closed - discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18226",
        "description": "Thermal Switch Clip Assembly, 3”, NC (normally closed - discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18227",
        "description": "Thermal Switch Clip Assembly, 5”, NC (normally closed - discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18223",
        "description": "Thermal Switch Clip Assembly, 8”, NO  (normally open – discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18228",
        "description": "Thermal Switch Clip Assembly, 8”, NC (normally closed - discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15300",
        "description": "Stat-X, 30T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15310",
        "description": "Stat-X, 60T – specific applications only",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15311",
        "description": "Stat-X, 60MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15410",
        "description": "Stat-X, 100T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15510",
        "description": "Stat-X, 250T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15511",
        "description": "Stat-X, 250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15610",
        "description": "Stat-X, 500T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15711",
        "description": "Stat-X, 1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15710",
        "description": "Stat-X, 1000T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15300",
        "description": "Stat-X, 30T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15310",
        "description": "Stat-X, 60T – specific applications only",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15311",
        "description": "Stat-X, 60MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15410",
        "description": "Stat-X, 100T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15510",
        "description": "Stat-X, 250T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15511",
        "description": "Stat-X, 250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15610",
        "description": "Stat-X, 500T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15711",
        "description": "Stat-X, 1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15710",
        "description": "Stat-X, 1000T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "16103",
        "description": "Discharge Station",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "16104",
        "description": "Event sign, small",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "16105",
        "description": "Event sign, large",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18001",
        "description": "Mounting Bracket, 2” - 30T/60T/60MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18002",
        "description": "Mounting Bracket, 2” - 30T/60T/60MT, Single Mount",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18005",
        "description": "Mounting Bracket, 3” - 100T/250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18006",
        "description": "Mounting Bracket, 3” Heavy Duty - 100T/250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18010",
        "description": "Mounting Bracket, 5” - 250T/500T/1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18011",
        "description": "Mounting Bracket, 5” Heavy Duty - 250T/500T/1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18201",
        "description": "2” Bracket – External Mount (fits 30T, 30E, 60T, 60MT, and 60E units)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18205",
        "description": "External Mounting Bracket, 3\" - 100T/250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18015",
        "description": "Mounting Bracket, 8” - 1000T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18016",
        "description": "Mounting Bracket, 8” Heavy Duty - 1000T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20142",
        "description": "Head, Thermal, 158°F/70°C, AL",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20143",
        "description": "Head, Thermal, 203F/95°C, AL",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20144",
        "description": "Head, Thermal, 254°F/123°C, AL",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20152",
        "description": "Head, Thermal, 158°F/70°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20153",
        "description": "Head, Thermal, 203°F/95°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20154",
        "description": "Head, Thermal, 254°F/123°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20152",
        "description": "Head, Thermal, 158°F/70°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20153",
        "description": "Head, Thermal, 203°F/95°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20154",
        "description": "Head, Thermal, 254°F/123°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20105",
        "description": "T/M head, 203°F/95°C, Vertical Pull, Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20106",
        "description": "T/M Head, 254°F/123°C, Horizontal Pull, Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20107",
        "description": "T/M head, 254°F/123°C, vertical pull, alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20112",
        "description": "T/M Head, 158°F/70°C, Horizontal Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20113",
        "description": "T/M head, 158°F/70°C, vertical pull, brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20115",
        "description": "T/M Head, 203°F/95°C, Vertical Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20114",
        "description": "T/M Head, 203°F/95°C, Horizontal Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20117",
        "description": "T/M Head, 254°F/123°C, Vertical Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20102",
        "description": "T/M Head, 158F/70C, Horizontal Pull, Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20103",
        "description": "T/M Head, 158F/70C, Vertical Pull, Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20104",
        "description": "T/M Head, 203F/95C, Horizontal Pull,Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20116",
        "description": "T/M Head, 254°F/123°C, Horizontal Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20105",
        "description": "T/M head, 203°F/95°C, Vertical Pull, Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20106",
        "description": "T/M Head, 254°F/123°C, Horizontal Pull, Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20107",
        "description": "T/M head, 254°F/123°C, vertical pull, alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20112",
        "description": "T/M Head, 158°F/70°C, Horizontal Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20113",
        "description": "T/M head, 158°F/70°C, vertical pull, brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20115",
        "description": "T/M Head, 203°F/95°C, Vertical Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20114",
        "description": "T/M Head, 203°F/95°C, Horizontal Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20117",
        "description": "T/M Head, 254°F/123°C, Vertical Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20102",
        "description": "T/M Head, 158F/70C, Horizontal Pull, Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20103",
        "description": "T/M Head, 158F/70C, Vertical Pull, Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20104",
        "description": "T/M Head, 203F/95C, Horizontal Pull,Alum",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20116",
        "description": "T/M Head, 254°F/123°C, Horizontal Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18220",
        "description": "Thermal Switch Clip Assembly, 2”, NO (normally open – discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18221",
        "description": "Thermal Switch Clip Assembly, 3”, NO (normally open – discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18222",
        "description": "Thermal Switch Clip Assembly, 5”, NO  (normally open – discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18225",
        "description": "Thermal Switch Clip Assembly, 2”, NC (normally closed - discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18226",
        "description": "Thermal Switch Clip Assembly, 3”, NC (normally closed - discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18227",
        "description": "Thermal Switch Clip Assembly, 5”, NC (normally closed - discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18223",
        "description": "Thermal Switch Clip Assembly, 8”, NO  (normally open – discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18228",
        "description": "Thermal Switch Clip Assembly, 8”, NC (normally closed - discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18001",
        "description": "Mounting Bracket, 2” - 30T/60T/60MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18002",
        "description": "Mounting Bracket, 2” - 30T/60T/60MT, Single Mount",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18005",
        "description": "Mounting Bracket, 3” - 100T/250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18006",
        "description": "Mounting Bracket, 3” Heavy Duty - 100T/250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18010",
        "description": "Mounting Bracket, 5” - 250T/500T/1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18011",
        "description": "Mounting Bracket, 5” Heavy Duty - 250T/500T/1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18201",
        "description": "2” Bracket – External Mount (fits 30T, 30E, 60T, 60MT, and 60E units)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18205",
        "description": "External Mounting Bracket, 3\" - 100T/250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18015",
        "description": "Mounting Bracket, 8” - 1000T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18016",
        "description": "Mounting Bracket, 8” Heavy Duty - 1000T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20142",
        "description": "Head, Thermal, 158°F/70°C, AL",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20143",
        "description": "Head, Thermal, 203F/95°C, AL",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20144",
        "description": "Head, Thermal, 254°F/123°C, AL",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20152",
        "description": "Head, Thermal, 158°F/70°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20153",
        "description": "Head, Thermal, 203°F/95°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20154",
        "description": "Head, Thermal, 254°F/123°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20152",
        "description": "Head, Thermal, 158°F/70°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20153",
        "description": "Head, Thermal, 203°F/95°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20154",
        "description": "Head, Thermal, 254°F/123°C, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18220",
        "description": "Thermal Switch Clip Assembly, 2”, NO (normally open – discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18221",
        "description": "Thermal Switch Clip Assembly, 3”, NO (normally open – discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18222",
        "description": "Thermal Switch Clip Assembly, 5”, NO  (normally open – discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18225",
        "description": "Thermal Switch Clip Assembly, 2”, NC (normally closed - discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18226",
        "description": "Thermal Switch Clip Assembly, 3”, NC (normally closed - discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18227",
        "description": "Thermal Switch Clip Assembly, 5”, NC (normally closed - discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18223",
        "description": "Thermal Switch Clip Assembly, 8”, NO  (normally open – discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18228",
        "description": "Thermal Switch Clip Assembly, 8”, NC (normally closed - discharge notification)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15300",
        "description": "Stat-X, 30T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15310",
        "description": "Stat-X, 60T – specific applications only",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15311",
        "description": "Stat-X, 60MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15510",
        "description": "Stat-X, 250T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15511",
        "description": "Stat-X, 250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15610",
        "description": "Stat-X, 500T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15711",
        "description": "Stat-X, 1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15410",
        "description": "Stat-X, 100T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15710",
        "description": "Stat-X, 1000T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15300",
        "description": "Stat-X, 30T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15310",
        "description": "Stat-X, 60T – specific applications only",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15311",
        "description": "Stat-X, 60MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15510",
        "description": "Stat-X, 250T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15511",
        "description": "Stat-X, 250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15610",
        "description": "Stat-X, 500T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15711",
        "description": "Stat-X, 1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15410",
        "description": "Stat-X, 100T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15710",
        "description": "Stat-X, 1000T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "16053",
        "description": "Manual pull station sign",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18001",
        "description": "Mounting Bracket, 2” - 30T/60T/60MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18002",
        "description": "Mounting Bracket, 2” - 30T/60T/60MT, Single Mount",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18005",
        "description": "Mounting bracket, 3” - 100T/250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18006",
        "description": "Mounting Bracket, 3” Heavy Duty - 100E/250ME",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18010",
        "description": "Mounting Bracket, 5” - 250T/500T/1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18011",
        "description": "Mounting Bracket, 5” Heavy Duty  -250T/500T/1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14654",
        "description": "Manual Head, Vertical Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14655",
        "description": "Manual Head, Horizontal Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14686",
        "description": "200°F 3ft Cable pull assy, black T-handle",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14689",
        "description": "200°F 6 ft Cable pull, black assy T-handle,",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14687",
        "description": "Cable pull, black T-handle, 200°F 12ft",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14688",
        "description": "Cable pull, black T-handle, 200°F 40ft",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14682",
        "description": "Cable pull, red T-handle, 300°F 3ft",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14681",
        "description": "Cable pull, red T-handle, 300°F 12ft",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14667",
        "description": "Cable pull, red T-handle, 300°F 40ft",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14668",
        "description": "Cable pull, extender, 300°F 12ft",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14669",
        "description": "Cable pull, extender, 300°F 40ft",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14683",
        "description": "Weather-resistant wall-mount cover box",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14663",
        "description": "Pulley Tee",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14685",
        "description": "Sleeve, Oval, SS 304, 10-PAK, for 1/16\" Wire Rope Diameter",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14664",
        "description": "Oval sleeve tin-plated copper (package of 50)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14684",
        "description": "Steel 3\" corner L-brackets (for 300°F cables)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14698",
        "description": "Recessed stainless steel open cup (For use with 200°F-rated Cable Pull systems)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15300",
        "description": "Stat-X, 30T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15310",
        "description": "Stat-X, 60T – specific applications only",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15311",
        "description": "Stat-X, 60MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15510",
        "description": "Stat-X, 250T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15511",
        "description": "Stat-X, 250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15610",
        "description": "Stat-X, 500T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15711",
        "description": "Stat-X, 1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15410",
        "description": "Stat-X, 100T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15710",
        "description": "Stat-X, 1000T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15300",
        "description": "Stat-X, 30T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15310",
        "description": "Stat-X, 60T – specific applications only",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15311",
        "description": "Stat-X, 60MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15510",
        "description": "Stat-X, 250T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15511",
        "description": "Stat-X, 250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15610",
        "description": "Stat-X, 500T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15711",
        "description": "Stat-X, 1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15410",
        "description": "Stat-X, 100T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15710",
        "description": "Stat-X, 1000T",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "16053",
        "description": "Manual pull station sign",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18001",
        "description": "Mounting Bracket, 2” - 30T/60T/60MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18002",
        "description": "Mounting Bracket, 2” - 30T/60T/60MT, Single Mount",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18005",
        "description": "Mounting bracket, 3” - 100T/250MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18006",
        "description": "Mounting Bracket, 3” Heavy Duty - 100E/250ME",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18010",
        "description": "Mounting Bracket, 5” - 250T/500T/1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "18011",
        "description": "Mounting Bracket, 5” Heavy Duty  -250T/500T/1000MT",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14654",
        "description": "Manual Head, Vertical Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14655",
        "description": "Manual Head, Horizontal Pull, Brass",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14686",
        "description": "200°F 3ft Cable pull assy, black T-handle",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14689",
        "description": "200°F 6 ft Cable pull, black assy T-handle,",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14687",
        "description": "Cable pull, black T-handle, 200°F 12ft",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14688",
        "description": "Cable pull, black T-handle, 200°F 40ft",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14682",
        "description": "Cable pull, red T-handle, 300°F 3ft",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14681",
        "description": "Cable pull, red T-handle, 300°F 12ft",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14667",
        "description": "Cable pull, red T-handle, 300°F 40ft",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14668",
        "description": "Cable pull, extender, 300°F 12ft",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14669",
        "description": "Cable pull, extender, 300°F 40ft",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14683",
        "description": "Weather-resistant wall-mount cover box",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14663",
        "description": "Pulley Tee",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14685",
        "description": "Sleeve, Oval, SS 304, 10-PAK, for 1/16\" Wire Rope Diameter",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14664",
        "description": "Oval sleeve tin-plated copper (package of 50)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14684",
        "description": "Steel 3\" corner L-brackets (for 300°F cables)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14698",
        "description": "Recessed stainless steel open cup (For use with 200°F-rated Cable Pull systems)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15001",
        "description": "Stat-X First Responder® (4-pack): 1-19 cartons",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15001",
        "description": "Stat-X First Responder® (4-pack): 20-49 cartons",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15026",
        "description": "Carry case, yellow, for two (2) units, Foam in case is pre-cut. Stat-X First Responders are not included.",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15050",
        "description": "Mounting Bracket, Stat-X First Responder®",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15055",
        "description": "Carry Pouch, Stat-X First Responder®",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15045",
        "description": "Locator sign, 4” x 9” reflective “Stat-X First Responder®”",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14925",
        "description": "Stat-X First Responder®, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19052",
        "description": "Stat-X First Responder tri-fold brochure (set of 25)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19062",
        "description": "Fireaway company trifold (set of 25)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19069",
        "description": "3” x 4” Stat-X Post-It pad",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "15026",
        "description": "Carry case, yellow, for two (2) units",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14925",
        "description": "Stat-X First Responder®, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19266",
        "description": "Stat-X First Responder banner stand",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19090",
        "description": "Stat-X Overview Brochure (set of 25)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19062",
        "description": "Company trifold (set of 25)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19051",
        "description": "Marketing pocket folder (set of 10)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19444",
        "description": "Notebook 7” x 10”",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19069",
        "description": "3” x 4” Post-it notes",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19100",
        "description": "Men’s OGIO Sport shirt, blue with embroidered Stat-X logo on left crest Sizes: S, M, L, XL, 2XL",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19116",
        "description": "Women’s OGIO Sport shirt, blue with embroidered Stat-X logo on left crest Sizes: S, M, L, XL",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19445",
        "description": "Cotton twill cap with Stat-X AFS logo (white or dark gray)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19053",
        "description": "Power generator fire protection brochure (set of 25)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19054",
        "description": "Rolling stock fire protection brochure (set of 25)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19055",
        "description": "Utility fire protection brochure (set of 25)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19056",
        "description": "Wind turbine fire protection brochure (set of 25)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19057",
        "description": "Marine & offshore fire protection brochure (set of 25)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19058",
        "description": "Mining & tunnel fire protection brochure (set of 25)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19059",
        "description": "CNC machine fire protection brochure (set of 25)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19060",
        "description": "School Bus fire protection brochure (set of 25)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19267",
        "description": "Banner stand for systems for utilities",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19268",
        "description": "Banner stand for fixed systems",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19270",
        "description": "Product display",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19271",
        "description": "Banner stand for energy storage",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "17900",
        "description": "Kit, Product Sample Case",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19120",
        "description": "Stat-X 100E, cutaway display model",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14918",
        "description": "15E, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14901",
        "description": "30T, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14902",
        "description": "60E, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14915",
        "description": "60ME, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14903",
        "description": "60T, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14916",
        "description": "60MT, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14904",
        "description": "100E, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14905",
        "description": "100T, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14906",
        "description": "250E, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14930",
        "description": "250ME, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14907",
        "description": "250T, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14917",
        "description": "250MT, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14908",
        "description": "500E, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14909",
        "description": "500T, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14910",
        "description": "1000E, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14931",
        "description": "1000ME, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14932",
        "description": "1000MT, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14911",
        "description": "1500E, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14912",
        "description": "2500E, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20125",
        "description": "Head, thermal/manual, aluminum, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "20126",
        "description": "Head, thermal/manual, brass, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14933",
        "description": "1000T, inert",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "19049",
        "description": "Supplemental training, hr.",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "34500-01",
        "description": "1' Conduit Galvanized",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "34500-02",
        "description": "2' Conduit Galvanized",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "34511",
        "description": "Conduit Strap (one hole)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "34510",
        "description": "Conduit Strap Hanger",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "34500-04",
        "description": "4' Conduit Galvanized",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "34512",
        "description": "Conduit Strap (two hole)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "34513",
        "description": "Conduit Hanger with beam clamp",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "34515",
        "description": "Corner Pulley, Ball Bearing, Hi-temp",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "34514",
        "description": "Coupling, Straight,  1/2\" F/F, Compression Fit",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14663",
        "description": "Pulley Tee",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "34520",
        "description": "Wire Rope 1/16\" (7x7 strand), per foot",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "14685",
        "description": "Sleeve, Oval, SS 304, 10-PAK, for 1/16\" Wire Rope Diameter",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "34522",
        "description": "Thimble (for 1/16\" wire rope, SS)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "34530",
        "description": "Back Box",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "34540",
        "description": "Pull Station",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "34541",
        "description": "Pull Station Cover, Flush Mount, \"Fire\" Label, Red",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "34545",
        "description": "Wire rope cutter and crimper",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "34546",
        "description": "Conduit Cutter (rigid)",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "34547",
        "description": "Conduit Backbox Fitting/Connector",
        "incoterms": "Miami"
      },
      {
        "category": "Aerosol Suppression",
        "partNumber": "3005014",
        "description": "Ematch protection device (EPD) (required for all UL installations)",
        "incoterms": "Miami"
      }
    ]
  }
];
